import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';

import { useTranslation } from "react-i18next";
import moment from "moment";
import Swal from "sweetalert2";

import {
    Button, Input, Label,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Form, FormGroup, FormFeedback,
    Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";

import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { Editor } from 'components/TinyMCE-react';

import FilesCustom, { ExtUpload } from 'components/FilesCustom';
import EditorCustom from 'components/EditorCustom';
import ReportFinal from 'components/ReportFinal';
import ShowDetails from 'components/ShowDetails';
import Historical from 'components/Historical';

import CNavbar from 'components/CNavbar';

import * as commonFunc from 'scripts/common';
import CDataTable, { showDtPrevID, showDtSelID, showDtNextID, setDtNoSelect } from "components/CDataTable";

import AGenerateModel from 'components/generic/AGenerateModel';

import { withRouter } from 'components/withRouter';

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

class ManageReportsItv extends Component {
    static displayName = ManageReportsItv.name;

    static reportSchema;
    static reportModels;
    static refreshCb;
    static modalRoot;
    static dtFunctions;

    static loadReportCb;

    modalGenManager = React.createRef();

    constructor(props) {
        super(props);

        this.reportGen = React.createRef(null);
        this.editorRef = React.createRef(null);

        var defReportCategoryGroupKey = "";
        var defReportPageModels = "";
        if (props.searchParams) {
            defReportCategoryGroupKey = props.searchParams.get("categoryGroupKey") || "";
            defReportPageModels = props.searchParams.get("pageModels") || "";
        }


        this.state = {
            reports: [], curReport: null, curReportId: 0, status: [], defaultStatus: 212, curStatus: 212, historicalReports: true, filterReports: false, loading: true, dataStamp: 0, activeTab: "1",
            title: props.i18nManager.t("report.noSelected"), editionMode: false, categoryGroupKey: defReportCategoryGroupKey, pageModels: defReportPageModels
        };
    }

    componentDidMount() {
        //console.debug("MOUNT");

        var context = this;

        if (this.props.updateUser) this.props.updateUser(function (curUser) {

            commonFunc.getMethod("../api/report/GetReportModels", { id: -1 }).then((responseModels) => {
                var dataModels = responseModels.data;
                if (dataModels.isSuccess) {

                    context.reportModels = {};
                    dataModels.result.models.forEach((model) => {
                        context.reportModels[model.extID] = JSON.parse(model.value);
                    });
                    
                    //client 1404008 -> AAD (SMS)
                    //client 1404007 -> (ADD/UPD ReportDraft)
                    //client 1404013 -> (ADD/UPD ReportDraft)
                    //client 1404020 -> (ADD ManualReport)
                    //client 1404024 -> (ADD ManualReport)
                    //OPT client 1404016 -> (Accès page MatOrders)

                    /*context.loadEmpOptgrp("reportLstEmp", 0, 0, function (dataEmp) {
                        loadEmpOptgrpByCache("select.mask-loading-emp", dataEmp, 0);
                    });

                    context.loadSvcOptgrp("reportLstSvc", 0, 0);

                    context.loadSubStatusBtnGrp("btnLstSubStatus", 350, 'SREPORT');

                    context.loadFlowsType("targetMsgType", 0, 2, false);*/

                    /*if (this.props.dataCfg && this.props.dataCfg.dlgSup_checkEnd_1) {
                        initNewManualReport(true);
                    }
                    else {
                        initNewManualReport();
                    }
 
                    initNewDraft();*/

                    /*commonFunc.getMethod("../api/report/GetSchemaModel", null).then((response) => {
                        var dataSchema = response.data
                        if (dataSchema.isSuccess) {

                            context.reportSchema = dataSchema.result;*/

                            //Chargement via url
                            var defReportLoadId = 0;
                            var defReportActionId = 0;
                            if (context.props.searchParams) {
                                defReportLoadId = parseInt(context.props.searchParams.get("reportId")) || 0;
                                defReportActionId = parseInt(context.props.searchParams.get("actionId")) || 0;
                            }
                            if (defReportLoadId > 0) {
                                var defReportStatusId = parseInt(context.props.searchParams.get("statusId")) || 212;
                                context.loadStatusBtnGrp(defReportStatusId);

                                context.refreshCb = () => {
                                    if (context) {
                                        context.loadReportCb = () => {
                                            if (defReportActionId) context.switchTab(defReportActionId.toString());

                                            //ScrollTo bottom tableContainer
                                            //setTimeout(function () {
                                            var element = document.querySelector('.tableContainer');
                                            if (element) {
                                                const elementBottom = element.offsetTop + element.offsetHeight - 93;//marginTop - mainPanel/content
                                                context.props.getScroller().smoothScroll(elementBottom /*|| 1500*/);
                                            }
                                            //}, 2000);
                                        };
                                    }
                                    showDtSelID("tableReports", defReportLoadId);
                                };
                                if (context.state.curStatus === defReportStatusId) context.getReports();
                                else context.setState({ curStatus: defReportStatusId, curReportId: defReportLoadId });
                            } else {
                                context.loadStatusBtnGrp(212);

                                context.getReports();

                                if (defReportActionId) context.switchTab(defReportActionId.toString());

                                /*if (defReportActionId == 1) {
                                    $(".action-addReport:visible").click();
                                }*/
                            }

                        /*}
                        else {
                            Swal.fire({
                                icon: "error",
                                title: "Erreur",
                                html: "Erreur lors de la récupération du schéma intervention"
                            });
                        }
                    });*/
                } else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_failLoadModels") + " :<br>" + dataModels.errorMessage
                    });
                }
            });
        });

    }

    componentDidUpdate(prevProps, prevState) {
        //console.debug("UPDATE");
        if (prevState.historicalReports !== this.state.historicalReports || prevState.filterReports !== this.state.filterReports || prevState.curStatus !== this.state.curStatus || prevState.categoryGroupKey !== this.state.categoryGroupKey || prevState.pageModels !== this.state.pageModels) {
            this.getReports();
        }
        else {
            //if (this.dtFunctions && this.dtFunctions["tableReports"] && this.dtFunctions["tableReports"].resizeResponsive && prevState.curReportId !== this.state.curReportId) this.dtFunctions["tableReports"].resizeResponsive();

            var defReportCategoryGroupKey = "";
            var defReportPageModels = "";
            if (this.props.searchParams) {
                defReportCategoryGroupKey = this.props.searchParams.get("categoryGroupKey") || "";
                defReportPageModels = this.props.searchParams.get("pageModels") || "";
            }

            if (this.state.categoryGroupKey !== defReportCategoryGroupKey || this.state.pageModels !== defReportPageModels) {
                this.setState({ categoryGroupKey: defReportCategoryGroupKey, pageModels: defReportPageModels });
            }
        }

        //Update Scroller Size
        if (prevState.isShowDetails && !this.state.isShowDetails) {
            if (this.props.getScroller && this.props.getScroller().update) this.props.getScroller().update();
        }

        //Callback initCreateReport
        if (this.state.curReportId === 0 /*&& prevState.curReportId !== this.state.curReportId*/ && this.state.editionMode && !this.state.isShowDetails) {
            this.setState({ isShowDetails: true });
        }
        if (prevState.editionMode !== this.state.editionMode && this.dtFunctions && this.dtFunctions["tableReports"]) this.dtFunctions["tableReports"].setDisabled(this.state.editionMode);
    }

    componentWillUnmount() {
        //console.debug("unmount");
        if (this.modalRoot) {
            this.modalRoot.unmount(); 
            this.modalRoot = null;
        }
    }

    dtFunctionPanel(id, fctPanel) {
        if (!this.dtFunctions) this.dtFunctions = {};
        if (!this.dtFunctions[id]) this.dtFunctions[id] = {};
        this.dtFunctions[id] = fctPanel;
    }

    render() {
        var context = this;

        var listCb = function () {
            if (context.refreshCb) {
                if (context.refreshCb && typeof (context.refreshCb) === "function") { context.refreshCb(); }
                context.refreshCb = null;
            }
        };

        //TODO : createdCell >> dépendance du contexte pour éxecution de la fonction
        var dtConfig = {
            columnDefs: [
                {
                    createdCell: (td, cellData, rowData, row, col) => {
                        var currRoot = createRoot(td);
                        currRoot.render(<Button className='btn-icon btn-simple m-0' color="dark" size="sm" disabled={this.state.editionMode}
                            onClick={() => {
                                if (context) {
                                    context.loadReportCb = () => {
                                        //setTimeout(function () {
                                        var element = document.querySelector('.tableContainer');
                                        if (element) {
                                            const elementBottom = element.offsetTop + element.offsetHeight - 93;//marginTop - mainPanel/content
                                            context.props.getScroller().smoothScroll(elementBottom /*|| 1500*/);
                                        }
                                        //}, 2000);
                                    };
                                }
                                showDtSelID("tableReports", rowData.idReport);
                            }} title={context.props.i18nManager.t("gal_show")}><i className='fa fa-eye'></i></Button>);
                    }, "targets": "renderingShow"
                },
            ],
            dtOnSelect: function (dataSel) {
                var id = dataSel.idReport;
                if (parseInt(id) > 0) {
                    if (!context.state.editionMode) context.loadReport(id, dataSel);
                }
            },
            dtOnUnselect: function (dataSel) {
                if (!context.state.editionMode) context.loadReport();
            },
            dtOnDblClick: function (event) {
                /*var id = parseInt(getDtSelID("lstActs"));
                var currId = parseInt($(this).closest("tr").prop("id"));
                if (currId != id) {
                    scrollToId("detailAct");
                    showDtSelID("lstActs", currId);
                }
                else {
                    if (currId > 0) {
                        scrollToId("detailAct");
                    }
                }*/
            },
            cbInitComplete: function (cRootList) {
                //Swal.close();

                /*cRootList.map((prop, elem) => {
                    console.debug(elem);
                    if (elem.classList.contains("cneedroot")) {
                        var rootElem = createRoot(elem);
                        switch (elem.getAttribute("cneedroot")) {
                            case "forceLogout":
                                rootElem.render(<button className="btn btn-primary btn-icon" onClick={() => context.forceLogout('hey!')}><i className='fa fa-edit'></i></button>);
                                break;
                            default:
                                break;
                        }
                    }
                    return null;
                });*/

                //$("#report_select_filters").appendTo($(".dt-buttons").parent().parent());
                //$("#report_select_filters").removeClass("d-none").addClass("d-inline-block");

                //updateSidebar();

                listCb();
            },
            cbCustom: function () {
                listCb();
            }
        };

        //console.debug("render again");

        var altT = (label, args) => { return (label && label.startsWith("i18n:")) ? context.props.i18nManager.t(label.replace("i18n:", ""), args) : label };
        var pageConfig;
        switch (context.state.pageModels) {
            case "NOADD":
                pageConfig = {
                    "objType": "model", "templates": [
                        { "title": "i18n:report.tabDetails", "objType": "template", "subType": "REPORT", "checkRights": { "entity": "REPORT", "rights": "R" } },
                        { "title": "i18n:report.tabContacts", "objType": "template", "subType": "CONTACTS", "checkRights": { "entity": "REPORT_CONTACTS", "rights": "L" } },
                        { "title": "i18n:report.tabDocs", "objType": "template", "subType": "FILES", "checkRights": { "entity": "REPORT_FILES", "rights": "L" } },
                        { "title": "i18n:report.tabPreview", "objType": "template", "subType": "PREVIEW", "checkRights": { "entity": "REPORT", "rights": "U" } },
                        { "title": "i18n:report.tabFinalize", "objType": "template", "subType": "FINALIZE", "checkRights": { "entity": "REPORT_FILES", "rights": "R" } },
                        { "title": "i18n:report.tabFlows", "objType": "template", "subType": "FLOWS", "checkRights": { "entity": "REPORT_FLOWS", "rights": "L" } }
                    ]
                };
                break;
            default:
                pageConfig = {
                    "objType": "model", "templates": [
                        { "title": "i18n:report.tabDetails", "objType": "template", "subType": "REPORT", "checkRights": { "entity": "REPORT", "rights": "R" } },
                        { "title": "i18n:report.tabContacts", "objType": "template", "subType": "CONTACTS", "checkRights": { "entity": "REPORT_CONTACTS", "rights": "L" } },
                        { "title": "i18n:report.tabDocs", "objType": "template", "subType": "FILES", "checkRights": { "entity": "REPORT_FILES", "rights": "L" } },
                        { "title": "i18n:report.tabPreview", "objType": "template", "subType": "PREVIEW", "checkRights": { "entity": "REPORT", "rights": "U" } },
                        { "title": "i18n:report.tabFinalize", "objType": "template", "subType": "FINALIZE", "checkRights": { "entity": "REPORT_FILES", "rights": "R" } },
                        { "title": "i18n:report.tabFlows", "objType": "template", "subType": "FLOWS", "checkRights": { "entity": "REPORT_FLOWS", "rights": "L" } },
                        { "title": "i18n:report.add", "objType": "button", "subType": "ADD", "checkRights": { "entity": "REPORT", "rights": "C" } }
                    ]
                };
                break;
        }



        var getSysCpt = (template, index) => {
            var curUser = this.props.getUser();
            var targetRoles = curUser.roles ? curUser.roles[0] : null;
            var reportModel;
            var srcModel;
            var resFilter = Object.keys(this.reportModels).filter((key) => {
                var model = this.reportModels[key];
                if (key === "REPORT" || key === ("REPORT_" + this.state.curReport?.categoryID)) {
                    if (model.siteID > 0 || (model.siteID === -1 && !srcModel)) {
                        srcModel = model;
                    }
                }

                return key === "REPORT_" + targetRoles || (key === ("REPORT_" + this.state.curReport?.categoryID + "_") + targetRoles);
            });
            if (resFilter && resFilter.length) {
                reportModel = this.reportModels[resFilter[0]];
            }
            else if (srcModel) {
                reportModel = srcModel;
            }
            else {
                reportModel = this.reportModels ? (this.reportModels["REPORT_" + this.state.curReport?.categoryID] || this.reportModels["REPORT"]) : {};
            }

            var cptSysCollection = {
                "REPORT": <ShowDetails id={this.state.curReportId} type="report" genRef={this.reportGen} data={this.state.curReport} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={reportModel} modelsList={this.reportModels} loadList={this.loadReports.bind(this)} loadElem={this.loadReport.bind(this)} saveElem={this.saveReport.bind(this)} removeElem={this.removeReport.bind(this)} updateStatusElem={this.updateReportStatus.bind(this)} setEditingMode={this.setEditingMode.bind(this)} formEditing={this.state.editionMode} switchTab={this.switchTab.bind(this)} shouldRender={this.state.activeTab === index.toString()} />,
                "CONTACTS": <ShowDetails id={this.state.curReportId} type="reportContacts" data={this.state.curReport} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={this.reportModels ? this.reportModels["CONTACTS"] : {}} modelsList={this.reportModels} shouldRender={this.state.activeTab === index.toString()} />,
                "FILES": <Form id="frmaupdact3">
                    <FilesCustom className="report-files" bindID={this.state.curReportId} rightType={template?.checkRights?.entity} checkRights={this.props.checkRights} fileTypeID="REPORT" src={this.state.curReport} srcName={this.state.curReport ? this.state.curReport.name : ""} withFilters={true} shouldRender={this.state.activeTab === index.toString()} defaultFileType={"PJ"} altFilesTypes="../api/report/GetReportFilesType" altFilesUrl="../api/report/GetReportFiles" altRemoveFilesUrl="../api/report/RemoveReportFile" altUploadFilesUrl="../api/report/UploadReportFiles" />
                </Form>,
                "FLOWS": <Row className="report-history">
                    <Col lg="12">
                        <Card className="widget dash">
                            <CardHeader>
                                <CardTitle tag="h6">{context.props.i18nManager.t("report.flowsTitle")}</CardTitle>
                                <div className="widget-tools collapse-tool">
                                    <i className="fa fa-history fa-4x"></i>
                                </div>
                                <div className='borderTheme'></div>
                            </CardHeader>
                            <CardBody>
                                <Historical type="report" elemId={context.state.curReportId} url="../api/report/GetReportFlows" getRoutes={context.props.getRoutes} shouldRender={context.state.activeTab === index.toString()} />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>,
                "PREVIEW": <Row>
                    <Col sm="12">
                        <EditorCustom ref={this.editorRef} report={context.state.curReport} reportId={context.state.curReportId} checkRights={this.props.checkRights} serviceId={context.state.curReport ? context.state.curReport.benefitID : 0} templateId={context.state.curReport ? context.state.curReport.templateID : 0} updateReportStatus={this.updateReportStatus.bind(this)} loadReport={this.loadReport.bind(this)}
                            removePDFReport={this.removePDFReport.bind(this)} nextTab={() => this.setState({ activeTab: (index+1).toString() })} refreshReport={(report) => this.setState({ curReport: report })} dataCfg={this.props.dataCfg} parentProps={context.props} />
                    </Col>
                </Row>,
                "FINALIZE": <Row className="report-final">
                    <Col lg="12">
                        <Card className="widget dash">
                            <CardHeader>
                                <CardTitle tag="h6">{context.props.i18nManager.t("report.finalizeTitle")}</CardTitle>
                                <div className="widget-tools collapse-tool">
                                    <i className="fa fa-file-pdf fa-4x"></i>
                                </div>
                                <div className='borderTheme'></div>
                            </CardHeader>
                            <CardBody>
                                <ReportFinal report={context.state.curReport} reportId={context.state.curReportId} checkRights={this.props.checkRights} shouldRender={context.state.activeTab === index.toString()} updateReportStatus={this.updateReportStatus.bind(this)}
                                    loadReport={this.loadReport.bind(this)} removePDFReport={this.removePDFReport.bind(this)} sendEmail={false ? this.sendEmailDialog.bind(this) : this.sendEmail.bind(this)} dataCfg={this.props.dataCfg}></ReportFinal>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>,
            };

            return <TabPane key={"tabpane" + template.subType + index} tabId={index.toString()}>{this.props.checkRights(template?.checkRights?.entity, template?.checkRights?.rights) ? cptSysCollection[template.subType] : ""}</TabPane>;
        };

        let contents = this.state.loading ? <p><em>{context.props.i18nManager.t("gal_loading")}</em></p> :
            <div>
                {this.reportModels ? <CDataTable key="reports" dtId={"tableReports"} data={this.state.reports} localConfig={dtConfig} tag={"DT_RPTS"} config={this.reportModels["DT_RPTS"]} stamp={this.state.dataStamp} functionPanel={this.dtFunctionPanel.bind(this)}
                    className="table-striped table-hover nowrap" style={{ fontSize: "90%" }} /> : ""}
            </div>;


        return (
            <div className="tableDetails">
                <Card className={`tableContainer widget dash ${this.state.editionMode ? "module-disabled" : ""}`}>
                    <CardHeader>
                        <CardTitle tag="h6">{context.props.i18nManager.t("report.title")}</CardTitle>
                        <div className="widget-tools collapse-tool">
                            <i className="fa fa-table-list fa-4x"></i>
                        </div>
                        <div className='borderTheme'></div>
                    </CardHeader>
                    <CardBody>
                        <div className="float-start">
                            <Button className="btn-rotate px-2 btn-simple mt-0" disabled={this.state.editionMode} color="dark" size="sm" onClick={() => this.getReports()}>
                                <i className="fa fa-sync"></i>{context.props.i18nManager.t("gal_refresh")}
                            </Button>
                            {pageConfig?.templates?.map((template, index) => {
                                if (template.objType === "button" && this.props.checkRights(template.checkRights?.entity, template.checkRights.rights)) {
                                    switch (template.subType) {
                                        case "ADD":
                                            return <Button key={"addbtn"} className="btn-magnify px-2 mt-0" disabled={this.state.editionMode} color="success" size="sm" onClick={() => this.showManualReport()}>
                                <i className="fa fa-plus-square"></i>{context.props.i18nManager.t("report.add")}
                                            </Button>;
                                        default: return "";
                                    }
                                }
                                else return "";
                            })}
                            {this.props.checkRights("REPORT", "C") ? <Button className="btn-magnify px-2 mt-0 d-none" disabled={this.state.editionMode} color="success" size="sm" onClick={() => this.showDraft()}>
                                <i className="fa fa-plus-square"></i>{context.props.i18nManager.t("report.add")}
                            </Button> : ""}
                            <FormGroup check inline className='fcheck-sm ms-2 d-none'>
                                <Label check className="fs-6 text-dark" >
                                    <Input checked={this.state.filterReports} type="checkbox" disabled={this.state.editionMode} onChange={() => this.setState({ filterReports: !this.state.filterReports })} />
                                    <span className="form-check-sign" />
                                    Filtrage Configuration
                                </Label>
                            </FormGroup>
                            <FormGroup check inline className='fcheck-sm ms-2'>
                                <Label check className="fs-6 text-dark" >
                                    <Input checked={this.state.historicalReports} type="checkbox" disabled={this.state.editionMode} onChange={() => this.setState({ historicalReports: !this.state.historicalReports })} />
                                    <span className="form-check-sign" />
                                    6 derniers mois
                                </Label>
                            </FormGroup>
                        </div>
                        <CNavbar className="float-end">
                            <div className="text-end">
                                {this.state.status.map((dt) => {

                                    //TODO : statusBtnAltProc

                                    var statusClass = "form-badge-radio mb-1 ";
                                    statusClass += dt.css ? dt.css.replace("fa-", "untrigger") : "";
                                    return dt.isSchedulable ? <div id={`st_${dt.idStatus}`} key={dt.idStatus} className={statusClass}>
                                        <div className='form-check-radio fcheck-sm mb-0'>
                                            <Label check >
                                                <Input id={`status_${dt.idStatus}`} name={"status"} disabled={this.state.editionMode} checked={dt.idStatus === context.state.curStatus} type="radio" data-lvlv={dt.step} value={dt.idStatus} onChange={(e) => {
                                                    var value = parseInt(e.target.value);
                                                    /*var last = parseInt(btnGrp.data("categ") || 0);
                                                    if ($(this).val() == 210 && last == 0) {
                                                        loadFilesType(64, true);
                                                        btnGrp.data("categ", 64);
                                
                                                    } else if ($(this).val() != 210 && last != 0) {
                                                        loadFilesType(0, true);
                                                        btnGrp.data("categ", 0);
                                                    }*/
                                                    context.setState({ curStatus: value, curReportId: 0, curReport: null, isShowDetails: false });
                                                }} />
                                                <span className="form-check-sign" />
                                                {(() => {
                                                    var classFa = "";
                                                    if (dt.css && dt.css.indexOf("fa-")) {
                                                        dt.css.split(" ").forEach((classElem) => {
                                                            //console.debug(classElem.startsWith("fa-") + classElem);
                                                            classFa += (classElem.startsWith("fa-") ? (classElem + " ") : "");
                                                        });
                                                    }
                                                    return <i className={`fa ${classFa} me-1`}></i>
                                                })()}
                                                {dt.idStatus === 210 ? dt.name.replace("fa-eur", "fa-euro-sign") : altT(dt.name)}
                                            </Label>
                                        </div>
                                    </div> : "";
                                })}
                            </div>
                        </CNavbar>
                        {contents}
                    </CardBody>
                </Card>

                {this.state.isShowDetails ? (<div className="detailsContainer">
                    <Card className="widget dash text-white" color="theme">
                        <CardHeader>
                            <Row>
                                <Col lg="10" className="offset-lg-1">
                                    <CardTitle tag="h6" className="text-center">
                                        {this.state.curReport?.status?.css && <div class={`${this.state.curReport?.status?.css?.replace(/label-/g, "bg-").replace(/label/g, "badge").replace("bg-default", "bg-secondary")} pt-2 pb-1 ps-2 pe-2 m-0 me-2`} data-bindid={this.state.curReport?.idReport} style={{ border: "1px solid #aaaaaa" }} >&nbsp;&nbsp;</div>}
                                        {this.state.title}
                                    </CardTitle>
                                </Col>
                                <Col lg="1" className="d-flex text-end float-end justify-content-end">
                                    <Button className="btn btn-icon my-0 text-dark" color="light" id="selActPrev" type="button" disabled={this.state.editionMode} onClick={() => {
                                        var prevId = context.state.curReportId || 0;
                                        showDtPrevID("tableReports", prevId);
                                    }}><i aria-hidden="true" className="fa fa-arrow-circle-left"></i></Button>
                                    <Button className="btn btn-icon my-0 text-dark" color="light" id="selActNext" type="button" disabled={this.state.editionMode} onClick={() => {
                                        var prevId = context.state.curReportId || 0;
                                        showDtNextID("tableReports", prevId);
                                    }}><i aria-hidden="true" className="fa fa-arrow-circle-right"></i></Button>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <Nav pills className={`${this.state.editionMode ? "invisible" : ""}`}>
                                {pageConfig?.templates?.filter(template => template.objType === "template").map((template, index) => (this.props.checkRights(template.checkRights?.entity, template.checkRights.rights) ? <NavItem key={"navItem" + index}><NavLink className={`${this.state.activeTab === (index + 1).toString() ? "active" : ""}`} onClick={() => { this.switchTab((index + 1).toString()) }}>{altT(template.title)}</NavLink></NavItem> : "") )}
                            </Nav>
                        </CardBody>
                    </Card>
                    <TabContent activeTab={this.state.activeTab}>
                        {pageConfig?.templates?.filter(template => template.objType === "template").map((template, index) => getSysCpt(template, index + 1))}
                    </TabContent></div>) : ""}
            </div>
        );
    }

    loadReports(id, statusId, callback) {
        if (statusId) {
            var context = this;
            this.refreshCb = (() => {
                if (id) {
                    if (context) {
                        context.loadReportCb = () => {
                            //setTimeout(function () {
                            var element = document.querySelector('.tableContainer');
                            if (element) {
                                const elementBottom = element.offsetTop + element.offsetHeight - 93;//marginTop - mainPanel/content
                                context.props.getScroller().smoothScroll(elementBottom /*|| 1500*/);
                            }
                            //}, 2000);
                        };
                    }
                    showDtSelID("tableReports", id);
                }
                if (callback && typeof (callback) === "function") { callback(); }
            });
            this.setState({ curStatus: statusId });
        }
        else {
            this.getReports(0, true, () => {
                if (id) {
                    if (context) {
                        context.loadReportCb = () => {
                            //setTimeout(function () {
                            var element = document.querySelector('.tableContainer');
                            if (element) {
                                const elementBottom = element.offsetTop + element.offsetHeight - 93;//marginTop - mainPanel/content
                                context.props.getScroller().smoothScroll(elementBottom /*|| 1500*/);
                            }
                            //}, 2000);
                        };
                    }
                    showDtSelID("tableReports", id);
                }
                if (callback && typeof (callback) === "function") { callback(); }
            });
        }
    }

    async getReports(statusId, forcedUpdate, callback) {
        if (!forcedUpdate && this.state.editionMode) return;
        this.setState({ reports: [], curReport: null, curReportId: 0/*, loading: true*/, dataStamp: 0, isShowDetails: false, editionMode: false });
        var context = this;

        if (callback) {
            context.refreshCb = callback;
        }

        Swal.fire({
            title: context.props.i18nManager.t("gal_loading"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        var args = {};
        if (this.state.historicalReports) {
            //args.startdate = new Date().toISOString();
            args.lastSync = new Date().toISOString();
            args.period = 'H6';
        }
        else {
            args.period = '*';
        }
        args.state = statusId || this.state.curStatus || 212;
        //args.period = "w";
        //args.sdate = stringToDate("31/05/2017 00:00").toISOString();
        //args.showAll = true;
        //args.withTemplate = false;
        args.level = 1;

        if (context.state.categoryGroupKey) args.categoryGroupKey = context.state.categoryGroupKey;

        commonFunc.getMethod("../api/report/GetReports", args).then((response) => {
            if (response.data) {
                if (response.data.isSuccess) {
                    if (context.state.filterReports) {
                        response.data.result = response.data.result.filter(function (elem, index) {
                            return !elem.startDate.startsWith("2099");
                        })
                    }

                    if (response.data.result) {
                        var filteredData = response.data.result.filter(function (dt, i) {
                            var flag = true;
                            var filter_reports_services = context.state.filter_reports_services;
                            var filter_reports_department = context.state.filter_reports_department;
                            var filter_reports_insurance = context.state.filter_reports_insurance;

                            flag &= dt.idReport !== 0;

                            if (!commonFunc.isBlank(filter_reports_services)) {
                                flag &= dt.serviceID == filter_reports_services;//benefitID ???
                            }
                            if (!commonFunc.isBlank(filter_reports_department)) {
                                if (dt.Address) {
                                    var cp = dt.address.pc;//dt.Address.match(/\d{5}/g);
                                    if (!commonFunc.isBlank(cp)) {
                                        flag &= parseInt(cp[cp.length - 1].substring(0, 2)) == filter_reports_department;
                                    }
                                    else {
                                        flag &= false;
                                    }
                                }
                                else {
                                    flag &= false;
                                }
                            }
                            if (filter_reports_insurance != 0 && !commonFunc.isBlank(filter_reports_insurance)) {
                                flag &= dt.insurance == filter_reports_insurance;
                            }

                            return flag;
                        });

                        response.data.result = filteredData;
                    }
                    //console.debug(filteredData);

                    /*$('#lstActs thead th').each(function () {
                        var title = $(this).text();
                        if ($(this).hasClass("searchable")) {
                            $(this).append('<input type="text" class="form-control col-lg-12 form-control-sm" placeholder="' + title + '" />');
                        }
                    });*/

                    Swal.close();
                    context.setState({ reports: response.data.result, loading: false, dataStamp: new Date().getTime(), isShowDetails: false });
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_error"),
                        html: context.props.i18nManager.t("report.failLoadReports") + " :<br>" + response.data.errorMessage
                    });
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_error"),
                    html: context.props.i18nManager.t("report.failLoadReports") + " :<br>" + response.data.errorMessage
                });
            }
        });

    }

    async getReportsTEST(statusId, callback) {//TEMP : test volume de données
        var context = this;

        Swal.fire({
            title: "Chargement en cours...",
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        commonFunc.getMethod("../api/data", null).then((response) => {
            console.debug(response.data);
            response.data = { isSuccess: true, result: response.data };

            if (response.data) {
                if (response.data.isSuccess) {
                    Swal.close();
                    context.setState({ reports: response.data.result, loading: false, dataStamp: new Date().getTime(), isShowDetails: false });
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: "Erreur",
                        html: "Erreur lors de la récupération des interventions :<br>" + response.data.errorMessage
                    });
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: "Erreur",
                    html: "Erreur lors de la récupération des interventions"
                });
            }
        });

    }

    loadStatusBtnGrp(defaultID) {
        var context = this;

        commonFunc.getMethod("../api/report/GetStatus", null).then((response) => {
            var data = response.data;

            //Libelle = name + ForeColor = foreColor + Opacite >> removed + Niveau = step + Categ = categ + Actif = isActive + Planifiable = isSchedulable + css + valeur = value
            if (data.isSuccess) {

                context.setState({ status: data.result, defaultStatus: defaultID, curStatus: defaultID });

            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_failLoadStatus") + "<br/>" + response.data.errorMessage
                });
            }

        });
    }

    async loadReport(id) {
        var context = this;

        var callback = this.loadReportCb;

        this.setState({ title: context.props.i18nManager.t("report.noSelected"), curReportId: 0, curReport: null, isShowDetails: (id > 0), editionMode: false });

        return new Promise((resolve, reject) => {

            var args = {};
            //args.state = 201;
            args.id = id;
            if (parseInt(id) > 0) {
                this.loadReportCb = null;
                Swal.fire({
                    title: context.props.i18nManager.t("gal_loading"),
                    didOpen: () => { Swal.showLoading() },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                });

                commonFunc.getMethod("../api/report/GetReport", args).then((response) => {
                    var data = response.data;
                    if (data.isSuccess) {
                        console.log(data.result);

                        if (callback && typeof (callback) === "function") { callback(data); }

                        Swal.close();

                        if (context.state.isShowDetails) context.setState({ title: (data.result.client.name + "  •  " + data.result.refID + "  •  " + data.result.agency.name), curReportId: id, curReport: data.result, isShowDetails: true });
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: context.props.i18nManager.t("gal_error"),
                            html: context.props.i18nManager.t("report.failLoadReport") + " :<br>" + data.errorMessage
                        });
                    }
                    resolve(data);
                });

            }
            else {
                resolve({ isSuccess: true, result: "" });
            }
        });
    }

    async saveReport(userReport, isUpdate) {
        var context = this;
        const dataReport = this.state.curReport || {};

        console.debug(userReport)
        /*userReport.employeeID = userReport.itv.employeeID;

        if (!userReport.itv.length) userReport.itv.length = dataReport.itv.length || 1.5;//TEMP

        //TODO : reprendre l'affichage heures variant en fonction du service
        //userReport.itv.startDate = new Date(userReport.itv.startDate);//TEMP : valeur mal stocké dans react hook form
        userReport.itv.endDate = commonFunc.addMinutes(userReport.itv.startDate, userReport.itv.length * 60);
        //userReport.itv.endDate = "2099-01-01T01:00:00";

        */

        //TODO : voir si on garde ce principe ou pas (>> création d'un nouveau rapport à chaque modification)
        /*var removeInfos;
        if (dataReport && dataReport.idReport) {
            removeInfos = {}
            var id = dataReport.idReport;
            if (id > 0) {//&& data.result.StatusID < 202
                removeInfos.id = id;
            }
            else {
                return;
            }
            removeInfos.isPermanent = false;

            userReport.dSysCreat = dataReport.DSysCreat;
        }
        else {
            userReport.dSysCreat = new Date();
        }*/



        if (!userReport.avoidMerge) {
            userReport = commonFunc.mergeDeep({}, dataReport, userReport);

            var startDate = userReport.itv.startDate;
            var endDate = userReport.itv.endDate;
            if (!(endDate instanceof Date)) {
                startDate = moment(startDate).utc().toDate();
                endDate = moment(endDate + "Z").toDate();
            }

            userReport.category = null;
            userReport.agency = null;
            userReport.client = null;//NEED
            userReport.service = null;
            userReport.subService = null;
            userReport.employee = null;//NEED Mobile/Gsm OU passage par Itv.Employee
            userReport.status = null;//NEED Css/Name
            userReport.subStatus = null;
            //userReport.itv = null;//NEED StartDate/Length/EmployeeID/Employee
            userReport.template = null;
            userReport.appTemplate = null;
            userReport.srcFile = null;
            userReport.resultFile = null;
            userReport.finalFile = null;
            userReport.material = null;
            userReport.manager = null;
            userReport.benefitMgr = null;
            userReport.parent = null;
            //userReport.address = null;
            //userReport.billAddress = null;

            //userReport.itv.employee = null;
        }

        console.debug(dataReport);
        console.debug(userReport);


        var flag = true;
        if (userReport.contacts) {
            userReport.contacts.forEach((contact) => {
                flag &= !(contact.isNotifiedSMS && commonFunc.isBlank(contact.gsm));
            });
        }
        //TODO : voir si possible de gérer les tests dans react hook form
        if (!(flag /*&& userReport.employeeID > 0*/ && commonFunc.isValidDate(startDate))) {
            console.debug(startDate);
            console.debug(commonFunc.isValidDate(startDate));
            if (!flag) {
                Swal.fire({
                    icon: 'warning',
                    title: "Veuillez renseigner un numéro de mobile pour Envoi Sms.",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                });
            }
            /*else if (userReport.employeeID <= 0) {
                Swal.fire({
                    icon: 'warning',
                    title: "Veuillez saisir un intervenant valide.",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                });
            }*/
            else {
                Swal.fire({
                    icon: 'warning',
                    title: "Veuillez saisir une date et/ou une heure valide.",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                });
            }
            return new Promise((resolve, reject) => {
                resolve({ isSuccess: false });
            });
        }
        if (!commonFunc.isValidDate(new Date(startDate)) || !commonFunc.isValidDate(new Date(endDate))) {
            Swal.fire({
                icon: 'error',
                title: 'Echec',
                html: "Veuillez renseigner des dates valides"
            });
            return new Promise((resolve, reject) => {
                resolve({ isSuccess: false });
            });
        }
        else if (startDate.getFullYear() > 1970 && moment(endDate).isBefore(startDate)) {
            Swal.fire({
                icon: 'error',
                title: 'Echec',
                html: "La date de fin d'intervention doit se situer après la date de début"
            });
            return new Promise((resolve, reject) => {
                resolve({ isSuccess: false });
            });
        }


        Swal.fire({
            title: context.props.i18nManager.t("gal_saving"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        console.debug(userReport);
        //return new Promise((resolve, reject) => { resolve({ isSuccess: false }); });//TEMP
        return commonFunc.postMethod(isUpdate ? "../api/report/UpdateReport" : "../api/report/CreateReport", userReport).then((response) => {
            Swal.close();
            return new Promise((resolve, reject) => {
                var data = response.data;
                if (data && data.isSuccess) {

                    //var assignAndSend = !commonFunc.isBlank(userReport.address.addressMain) && parseInt(userReport.itv.employeeID) > 0 && commonFunc.isValidDate(new Date(userReport.itv.startDate)) && commonFunc.isValidDate(new Date(userReport.itv.endDate));


                    /*var callbackSaveProc = async function (dataAssign) {

                        //TODO : Gestion des fichiers

                        //SUCCES GLOBAL
                        Swal.close();

                        if (assignAndSend && this.props.dataCfg && this.props.dataCfg.dlgSup_enableSend_1) {
                            Swal.fire({
                                icon: 'success',
                                title: "Chantier",
                                html: "L'intervention/Pochette a été ajoutée et préparée avec succès !<br><b>Voulez-vous envoyer le rapport au technicien ?</b>",
                                confirmButtonColor: "#5cb85c",
                                confirmButtonText: "Oui",
                                showCancelButton: true,
                                cancelButtonColor: "#d9534f",
                                cancelButtonText: "Non",
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                allowEnterKey: false,
                                didOpen: () => {
                                    Swal.hideLoading();

                                    if (dataAssign && !dataAssign.isSuccess) {
                                        $(".swal2-content").append("<br><b>Echec de l'assignation de l'intervenant :</b><br>" + dataAssign.errorMessage + "<br>");
                                    }
                                    if (errorFiles.length) {
                                        $(".swal2-content b").addClass("hidden");
                                        $(".swal2-confirm").addClass("hidden");
                                        $(".swal2-cancel").text("Fermer");
                                        $(".swal2-cancel").addClass("switch-btn");

                                        $(".swal2-content").append("<br><b>Certains fichiers n'ont pas pu être envoyés. Transférer les manuellement.</b>");
                                        $.each(errorFiles, function (i, e) {
                                            var div = $("<div class='text-danger' style='font-size:90%'>" + $(e).find(".file-name").text().replace($(e).find(".file-name small").text(), "") + "</div>");
                                            $(".swal2-content").append(div);
                                        });
                                    }
                                }
                            }).then((result) => {
                                if (result.value) {
                                    // handle confirm
                                    Swal.fire({
                                        title: 'Préparation du rapport...',
                                        onOpen: () => { Swal.showLoading() },
                                    });

                                    var args = { id: id, isSource: true, toStore: true };
                                    // getMethod("../api/reports/GetReportModel", args, function (data) {
                                    postMethod("../api/reports/AddReportModel", args, function (data) {
                                        if (data.isSuccess) {
                                            //Envoi direct
                                            Swal.close();
                                            Swal.fire({
                                                title: 'Envoi en cours...',
                                                onOpen: () => { Swal.showLoading() },
                                            });
                                            var req = { id: id, newStatus: 202, newStep: -1 };
                                            postMethod("../api/reports/UpdateStatus", req, function (data) {
                                                Swal.close();
                                                if (data && data.isSuccess) {
                                                    //loadReport(id);
                                                } else {
                                                    Swal.fire({
                                                        type: 'error',
                                                        title: "Echec de mise à jour du statut",
                                                        html: "<p>" + data.errorMessage + "</p>",
                                                    });
                                                }
                                                $("#btnLstItvsRefresh").click();

                                            });
                                        } else {
                                            Swal.close();
                                            Swal.fire({
                                                type: 'error',
                                                title: "Echec d'envoi sur la tablette. Procédez à son envoi manuellement.",
                                                html: "<p>" + data.errorMessage + "</p>",
                                            });
                                            $("#btnLstItvsRefresh").click();
                                        }

                                    });
                                }
                                else {
                                    $("#btnLstItvsRefresh").click();
                                }
                            });
                        }
                        else {
                            Swal.fire({
                                type: 'success',
                                title: "Chantier",
                                html: "L'intervention/Pochette a été ajoutée et préparée avec succès !",
                                onOpen: () => {
                                    Swal.hideLoading();

                                    if (dataAssign && !dataAssign.isSuccess) {
                                        $(".swal2-content").append("<br><b>Echec de l'assignation de l'intervenant :</b><br>" + dataAssign.errorMessage + "<br>");
                                    }
                                    if (errorFiles.length) {
                                        $(".swal2-content").append("<br><b>Certains fichiers n'ont pas pu être envoyés. Transférer les manuellement.</b>");
                                        $.each(errorFiles, function (i, e) {
                                            var div = $("<div class='text-danger' style='font-size:90%'>" + $(e).find(".file-name").text().replace($(e).find(".file-name small").text(), "") + "</div>");
                                            $(".swal2-content").append(div);
                                        });
                                    }
                                }
                            }).then((result) => {
                                $("#btnLstItvsRefresh").click();
                            });
                        }
                    };

                    if (removeInfos) {
                        postMethod("../api/reports/RemoveReport", removeInfos, function (dataRemove) {
                            hideBsModal("progressModal");
                            if (dataRemove && dataRemove.isSuccess) {
                                var mFiles = { id: id, targetId: removeInfos.id, isPermanent: true };
                                postMethod("../api/reports/MigrateFiles", mFiles, function (dataFilesMigration) {
                                    if (dataFilesMigration.isSuccess) {

                                        if (assignAndSend) {
                                            //assignDlgItv(id, itv, ad2, callbackRemoveProc);
                                            assignDlgItv(id, itv, ad2, callbackSaveProc);
                                        }
                                        else {
                                            callbackSaveProc();
                                        }
                                    } else {
                                        Swal.close();
                                        Swal.fire({
                                            type: 'error',
                                            title: "Echec de migration des documents de la pochette d'origine",
                                            html: "<p>" + dataFilesMigration.errorMessage + "</p>",
                                        });
                                    }
                                });
                            } else {
                                Swal.close();
                                Swal.fire({
                                    type: 'error',
                                    title: "Echec de la suppression de la pochette d'origine",
                                    html: "<p>" + dataRemove.errorMessage + "</p>",
                                });
                            }
                        });

                    } else {
                        if (assignAndSend) {
                            //assignDlgItv(id, itv, ad2, callbackRemoveProc);
                            assignDlgItv(id, itv, ad2, callbackSaveProc);
                        }
                        else {
                            callbackSaveProc();
                        }
                    }*/


                    var callbackSaveProc = async function (dataAssign) {
                        return new Promise((resolve, reject) => {
                            Swal.fire({
                                icon: "success",
                                title: context.props.i18nManager.t("gal_success"),
                                html: (isUpdate ? context.props.i18nManager.t("gal_successUpd") : context.props.i18nManager.t("gal_successAdd"))
                                    + ((dataAssign && !dataAssign.isSuccess) ? "<br><b>Echec de l'assignation de l'intervenant :</b><br>" + dataAssign.errorMessage + "<br>" : ""),
                                didOpen: () => {
                                    Swal.hideLoading();

                                    /*if (errorFiles.length) {
                                        $(".swal2-content").append("<br><b>Certains fichiers n'ont pas pu être envoyés. Transférer les manuellement.</b>");
                                        $.each(errorFiles, function (i, e) {
                                            var div = $("<div class='text-danger' style='font-size:90%'>" + $(e).find(".file-name").text().replace($(e).find(".file-name small").text(), "") + "</div>");
                                            $(".swal2-content").append(div);
                                        });
                                    }*/
                                },
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                allowEnterKey: false,
                            }).then((result) => {
                                /*context.getReports(0, true, () => {
                                    showDtSelID("tableReports", data.result.idReport);
                                });*/
                                context.loadReport(data.result.idReport);//userReport.idReport
                            });

                            data.result.idResponse = data.result.idReport;
                            resolve(data.result);
                        });
                    };


                    callbackSaveProc();


                } else {
                    var supErrors = "";
                    if (data.errors && data.errors.length) {
                        supErrors = data.errors.map((error) => {
                            return "<br>" + error.desc + "(" + error.value + ")";
                        });
                    }
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_errorSave") + " :<br>" + data.errorMessage + supErrors
                    });
                    resolve(data);
                }
            });
        });
    }

   assignDlgItv(report, callback) {
        var itvAssign = {};
       itvAssign.reportID = report.idReport;
       //itvAssign.reportItvID = report.idReport;
       //itvAssign.isSet = true;
       itvAssign.serviceID = report.serviceID;

        itvAssign.length = report.itv.length;

        /*var optionData = $("#aupdDlgRepLstSvc option:selected").data("cacheemp");
        switch (optionData.tag) {
            case "H":
                itvAssign.StartDate = stringToDate((isBlank($("#consDlg_site_sd").val()) ? "01/01/1970" : $("#consDlg_site_sd").val()) + " " + (isBlank($("#consDlg_site_sh").val()) ? "00:00" : $("#consDlg_site_sh").val()));
                itvAssign.EndDate = addMinutes(itvAssign.StartDate, itv.Length * 60);
                break;

            case "D", "DH":
                var valueSdDH = (isBlank($("#aupdItvSdDH").val()) ? "01/01/1970" : $("#aupdItvSdDH").val());
                switch (parseInt($("#aupdItvSdDHC").val())) {
                    case 0: //AM
                        itvAssign.StartDate = stringToDate(valueSdDH + ' 00:00');
                        itvAssign.EndDate = stringToDate(valueSdDH + ' 13:00');
                        break;
                    case 1:
                        itvAssign.StartDate = stringToDate(valueSdDH + ' 13:00');
                        itvAssign.EndDate = stringToDate(valueSdDH + ' 23:59');
                        break;
                    case 2:
                        itvAssign.StartDate = stringToDate(valueSdDH + ' 00:00');
                        itvAssign.EndDate = stringToDate(valueSdDH + ' 23:59');
                        break;

                }
                break;

            case "J":
                itvAssign.StartDate = stringToDate((isBlank($("#aupdItvSdJ").val()) ? "01/01/1970" : $("#aupdItvSdJ").val()) + ' 00:00');
                itvAssign.EndDate = stringToDate((isBlank($("#aupdItvEdJ").val()) ? "01/01/1970" : $("#aupdItvEdJ").val()) + ' 23:59');
                break;


            case "C", "DJ":
                var valueSdDJ = (isBlank($("#aupdItvSdDJ").val()) ? "01/01/1970" : $("#aupdItvSdDJ").val());
                switch (parseInt($("#aupdItvSdDJC").val())) {
                    case 0: //AM
                        itvAssign.StartDate = stringToDate(valueSdDJ + ' 00:00');
                        break;
                    case 1:
                        itvAssign.StartDate = stringToDate(valueSdDJ + ' 13:00');
                        break;
                    case 2:
                        itvAssign.StartDate = stringToDate(valueSdDJ + ' 00:00');
                        break;

                }
            
                var valueEdDJ = (isBlank($("#aupdItvEdDJ").val()) ? "01/01/1970" : $("#aupdItvEdDJ").val());
                switch (parseInt($("#aupdItvEdDJC").val())) {
                    case 0: //AM
                        itvAssign.EndDate = stringToDate(valueEdDJ + ' 13:00');
                        break;
                    case 1:
                        itvAssign.EndDate = stringToDate(valueEdDJ + ' 23:59');
                        break;
                    case 2:
                        itvAssign.EndDate = stringToDate(valueEdDJ + ' 23:59');
                        break;

                }
                break;


            case "JH":
                itvAssign.StartDate = stringToDate((isBlank($("#aupdItvSdJH").val()) ? "01/01/1970" : $("#aupdItvSdJH").val()) + ' ' + (isBlank($("#aupdItvShJH").val()) ? "00:00" : $("#aupdItvShJH").val()));
                itvAssign.EndDate = stringToDate((isBlank($("#aupdItvEdJH").val()) ? "01/01/1970" : $("#aupdItvEdJH").val()) + ' ' + (isBlank($("#aupdItvEhJH").val()) ? "00:00" : $("#aupdItvEhJH").val()));
                break;

        }*/
       itvAssign.startDate = report.itv.startDate;
       itvAssign.endDate = report.itv.endDate;


        itvAssign.employeeID = report.itv.employeeID;
       itvAssign.name = report.itv.employeeName;
       itvAssign.title = report.client.name + " [" + report.refID + "]    " + report.address.city;
       itvAssign.comments = report.address.addressMain + " " + report.address.addressPlus + " " + report.address.addressPlus2 + " " + report.address.pc + " " + report.address.city;

       /*if (report.employee) {
           itvAssign.phone = report.employee.gsm;
           itvAssign.tel = report.employee.tel;
       }*/

       //itvAssign.email = "";
       //itvAssign.version = report.refIDVersion;


       //TODO //TEMP : waiting ScheduleItvReport implementation
       //if (callback && typeof (callback) === "function") { callback(null); }


       //Assignation
       return commonFunc.postMethod("../api/report/ScheduleItvReport", itvAssign).then((response) => {
           var data = response.data;
            if (data && data.isSuccess) {


                if (callback && typeof (callback) === "function") { callback(data); }

            } else {
                Swal.close();
                Swal.fire({
                    icon: 'error',
                    title: "Echec de l'assignation de l'intervenant",
                    html: "<p>" + data.errorMessage + "</p>",
                });
                if (callback && typeof (callback) === "function") { callback(data); }
            }
        });
    }

    removeReport(id, title) {
        var context = this;
        return new Promise((resolve, reject) => {
            var row = context.state.curReport;
            if ((!id && row) || (id && row && id === row.idReport)) {
                id = id || row.idReport;
                title = row.refID;
                var sd = commonFunc.restStringToDate(row.itv.startDate);
                if (commonFunc.isValidDate(sd) && sd.getFullYear() > 1970) {
                    title += " du " + commonFunc.formatDateTime(moment(sd).utc(true).toDate());
                }
            }
            if (parseInt(id) > 0) {
                Swal.fire({
                    icon: "question",
                    title: context.props.i18nManager.t("gal_removing"),
                    html: context.props.i18nManager.t("report.rmvTitle") + "<br/>[" + id + "] " + title,
                    showCancelButton: true,
                    confirmButtonColor: "#28a745",
                    cancelButtonColor: "#dc3545",
                    confirmButtonText: context.props.i18nManager.t("gal_yes"),
                    cancelButtonText: context.props.i18nManager.t("gal_no"),
                }).then((result) => {
                    if (result.value) {
                        Swal.fire({
                            title: context.props.i18nManager.t("report.removing"),
                            didOpen: () => { Swal.showLoading() }
                        });
                        var req = { id: id, isPermanent: false };
                        commonFunc.postMethod("../api/report/RemoveReport", req).then((response) => {
                            Swal.close();
                            var data = response.data;
                            if (data && data.isSuccess) {
                                context.getReports();//TODO : check si besoin de refresh supplémentaire
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    title: context.props.i18nManager.t("gal_fail"),
                                    html: context.props.i18nManager.t("gal_errorRmv") + "<br/>" + response.data.errorMessage
                                });
                            }
                            resolve(data);
                        });

                    }
                    else {
                        resolve({ isSuccess: true, result: "" });
                    }
                });
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_noSelectedElem")
                });
                resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_noSelectedElem") });
            }
        });
    }


    updateReportStatus(statusId, stepId, customLabel) {
        var context = this;
        return new Promise((resolve, reject) => {
            var id = context.state.curReportId;
            if (parseInt(id) > 0) {
                if (statusId > 0) {
                    var label = "";
                    var reloadReport = true;

                    var curStatus = context.state.status.filter((status) => status.idStatus === statusId);
                    label = customLabel || (curStatus.length ? curStatus[0].name : "");

                    switch (statusId) {
                        case 206:
                            reloadReport = false;
                            break;
                        default:
                            break;
                    }


                    Swal.fire({
                        icon: "question",
                        title: context.props.i18nManager.t("report.updStatus"),
                        html: context.props.i18nManager.t("report.statusAs", [label]),
                        showCancelButton: true,
                        confirmButtonColor: "#28a745",
                        cancelButtonColor: "#dc3545",
                        confirmButtonText: context.props.i18nManager.t("gal_yes"),
                        cancelButtonText: context.props.i18nManager.t("gal_no"),
                    }).then((result) => {
                        if (result.value) {
                            Swal.fire({
                                title: context.props.i18nManager.t("report.updatingStatus"),
                                didOpen: () => { Swal.showLoading() },
                            });
                            var req = { id: id, newStatus: statusId, newStep: stepId || -1 };

                            commonFunc.postMethod("../api/report/UpdateStatus", req).then((response) => {

                                Swal.close();
                                if (response.data && response.data.isSuccess) {
                                    //if (reloadReport) context.loadReport(id);
                                    //context.getReports();//TODO : check si besoin de refresh supplémentaire
                                    /*context.getReports(0, true, () => {
                                        if (reloadReport) showDtSelID("tableReports", id);
                                    });*///TODO : check si besoin de refresh supplémentaire
                                    if (reloadReport) context.loadReport(id);
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: context.props.i18nManager.t("gal_fail"),
                                        html: context.props.i18nManager.t("gal_failUpdStatus") + "<br/>" + response.data.errorMessage
                                    });
                                }
                                resolve(response.data);
                            });
                        }
                        else {
                            resolve({ isSuccess: true, result: "" });
                        }
                    });
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_invalidStatus")
                    });
                    resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_invalidStatus") });
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_noSelectedElem")
                });
                resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_noSelectedElem") });
            }
        });
    }

    initCreateReport() {
        if (this.state.editionMode) return;
        setDtNoSelect("tableReports");
        //this.reportGen.current.resetForm();
        this.setState({ title: this.props.i18nManager.t("report.create"), curReportId: 0, curReport: null, isShowDetails: false, editionMode: true, activeTab: "1" });
    }

    switchTab(numTab, entity, action) {
        if (this.state.editionMode) return;

        if (action === "preview") {
            this.editorRef.current.loadPreview();
        }

        this.setState({ activeTab: numTab });

        return new Promise((resolve, reject) => {
            resolve({ isSuccess: false });
        });
    }

    setEditingMode(value, isDuplicate) {
        var title = this.state.curReport ? ((this.state.curReport.client?.compagny || this.state.curReport.client?.name) + "  •  " + this.state.curReport.refID + "  •  " + this.state.curReport.agency?.name) : "";
        this.setState({ title: (isDuplicate ? this.props.i18nManager.t("report.duplicate") : this.props.i18nManager.t("report.edit")) + " - " + title, editionMode: value });
    }

    showManualReport() {
        if (!this.reportModels) return;

        var context = this;

        var title = "Ajouter une Intervention/Pochette";

        if (this.modalRoot) {
            this.modalRoot.unmount();
            this.modalRoot = null;
        }

        //Traitement des informations retourné par le Dialog
        var callbackModal = function (data, isUpdate) {
            return new Promise((resolve, reject) => {
                if (data) {
                    context.addOrUpdateManualReport(data).then((dataResult) => {
                        if (dataResult && dataResult.idResponse) {
                            context.modalRoot.unmount();
                            resolve(dataResult);
                        }
                        else {
                            resolve(dataResult);
                        }
                    });
                }
                else {
                    context.modalRoot.unmount();
                    resolve();
                }
            });
        };
        if (this.reportModels["DLG_REPORT"]) {
            this.modalRoot = createRoot(document.createElement('div'));
            this.modalRoot.render(<ReportModal parentContext={this} title={title} configModel={this.reportModels["DLG_REPORT"]} modelsList={this.reportModels} callback={callbackModal}></ReportModal>);
        }
        else {
            Swal.fire({
                icon: "error",
                title: context.props.i18nManager.t("gal_error"),
                html: "Configuration introuvable"
            });
        }
    }

    showDraft() {
        
    }

    addOrUpdateManualReport(data, isUpdate) {

        const dataReport = this.state.curReport || {};

        //TODO : alimenter le sous-objet client avec les infos du 1er contact
        //name/firstname/tel/gsm/email/addresse
        return addReport(data, dataReport, isUpdate, { lengthSystem: true, translation: this.props.i18nManager.t }).then((dataResponse) => {
            var dataResult = dataResponse.result;
            console.debug(dataResponse);

            if (dataResult?.idResponse) {
                //this.loadReport(dataResult.idReport);
                this.loadReport(dataResult.idResponse);

                if (this.modalRoot) {
                    this.modalRoot.unmount();
                    this.modalRoot = null;
                }
            }
        });

    }

    removePDFReport(updateStatus, callback) {
        var context = this;

        var dataReport = this.state.curReport || {};
        var id = dataReport.idReport;
        if (parseInt(id) > 0) {

            var removeFileProc = () => {
                var req = { id: id, fileID: dataReport.resultFileID, isPermanent: true, fallbackStatusID: -1 };
                //var statusChange = $("#content").data("reportStatusOnPDFRemove");

                var statusChange = context.props.dataCfg ? context.props.dataCfg.reportStatusOnPDFRemove : -1;
                if (statusChange > 0 && dataReport.statusID > statusChange) {//Si config + Statut supérieur à "A corriger"
                    req.fallbackStatusID = parseInt(statusChange);
                }

                commonFunc.postMethod("../api/report/RemoveRelease", req).then((response) => {
                    var data = response.data;
                    Swal.close();
                    if (data && data.isSuccess) {
                        if (callback && typeof (callback) === "function") { callback(); }
                        context.loadReport(id);//if (req.fallbackStatusID > 0) { context.props.loadReport(id); }
                        // $("#btnLstItvsRefresh").click();
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: "Echec de suppression du Suppression du Rapport PDF<br/>" + data.errorMessage
                        });
                    }
                });
            };


            if (updateStatus) {
                Swal.fire({
                    icon: "question",
                    title: context.props.i18nManager.t("report.updStatus"),
                    html: context.props.i18nManager.t("report.statusAs", ["A Corriger"]),
                    showCancelButton: true,
                    confirmButtonColor: "#28a745",
                    cancelButtonColor: "#dc3545",
                    confirmButtonText: context.props.i18nManager.t("gal_yes"),
                    cancelButtonText: context.props.i18nManager.t("gal_no"),
                }).then((result) => {
                    if (result.value) {
                        Swal.fire({
                            title: context.props.i18nManager.t("report.updatingStatus"),
                            didOpen: () => { Swal.showLoading() },
                        });

                        //Changement de statut sans suppression de fichier
                        if (dataReport.resultFileID <= 0) {
                            var req = { id: id, newStatus: 203, newStep: -1 };

                            var statusChange = context.props.dataCfg ? context.props.dataCfg.reportStatusOnPDFRemove : -1;
                            if (statusChange && dataReport.statusID > statusChange) {//Si config + Statut supérieur à "A corriger"
                                req.newStatus = parseInt(statusChange);
                            }


                            commonFunc.postMethod("../api/report/UpdateStatus", req).then((response) => {
                                Swal.close();
                                if (response.data && response.data.isSuccess) {
                                    context.loadReport(id);
                                    if (callback && typeof (callback) === "function") { callback(); }
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: context.props.i18nManager.t("gal_fail"),
                                        html: context.props.i18nManager.t("gal_failUpdStatus") + "<br/>" + response.data.errorMessage
                                    });
                                }
                            });
                        }
                        //Suppressino de fichier + fallbackStatus
                        else {
                            removeFileProc();
                        }
                    }
                });
            }
            else {
                Swal.fire({
                    icon: "question",
                    title: "Suppression du Rapport PDF",
                    html: "Voulez-vous supprimer ce Rapport Final PDF ?",
                    showCancelButton: true,
                    confirmButtonColor: "#28a745",
                    cancelButtonColor: "#dc3545",
                    confirmButtonText: "Oui",
                    cancelButtonText: "Non",
                }).then((result) => {
                    if (result.value) {
                        Swal.fire({
                            title: 'Suppression du Rapport Final PDF...',
                            didOpen: () => { Swal.showLoading() },
                        });
                        removeFileProc();
                    }
                });
            }
        }
    }


    sendEmail() {
        var context = this;

        var id = this.state.curReportId;
        if (parseInt(id) > 0) {

            var args = {};
            var showProcessing = { flag: false };
            //var shouldConfirmProcess = { flag: false };

            Swal.fire({
                icon: "question",
                title: context.props.i18nManager.t("gal_confirmTitle"),
                html: context.props.i18nManager.t("gal_confirmAction"),
                showCancelButton: true,
                confirmButtonColor: "#28a745",
                cancelButtonColor: "#dc3545",
                confirmButtonText: context.props.i18nManager.t("gal_yes"),
                cancelButtonText: context.props.i18nManager.t("gal_no"),
            }).then((result) => {
                if (result.value) {
                    Swal.fire({
                        title: context.props.i18nManager.t("gal_processing", args),
                        html: "",
                        didOpen: () => { Swal.showLoading() },
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                    });

                    args.bindID = parseInt(id);
                    commonFunc.postMethod("../api/report/SendReportEmail", args).then((response) => {
                        //commonFunc.getMethod("../api/employee/GetWithContractAsKeyItems", args).then((response) => {
                        if (showProcessing.flag) Swal.close();

                        var data = response.data;
                        if (data.isSuccess) {
                            Swal.fire({
                                icon: "success",
                                title: "Succès",
                                html: "Envoi de l'email effectuée avec succès.",
                                didOpen: () => {
                                    Swal.hideLoading();
                                },
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                allowEnterKey: false,
                            }).then((result) => {
                                //context.loadReport(data.result.idReport);//userReport.idReport
                            });
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                title: "Erreur",
                                html: "Erreur lors de l'envoi du mail : " + data.errorMessage
                            });
                        }
                    });
                }
            });
        } else {
            Swal.fire({
                icon: "error",
                title: "Echec",
                html: "Aucune intervention n'est sélectionnée dans la liste"
            });
        }
    }

    sendEmailDialog() {
        var id = this.state.curReportId;
        if (parseInt(id) > 0) {
            var context = this;

            var report = context.state.curReport || {};
            var title = context.props.i18nManager.t("report.title") + " • " + report.refID + " " + report.refIDVersion + " • " + report.client?.name + " " + report.client?.firstName + (report.client?.compagny ? " - " + report.client?.compagny : "");// getDtValue("lstActs", id, "Name") + " " + getDtValue("lstActs", id, "FirstName");

            if (context.modalRoot) {
                context.modalRoot.unmount();
                context.modalRoot = null;
            }

            //Traitement des informations retourné par le Dialog
            var callbackModal = function () {
                context.modalRoot.unmount();
            };

            context.modalRoot = createRoot(document.createElement('div'));
            context.modalRoot.render(<EmailModal title={"Envoyer un Email  " + title} reportId={id} report={report} dataCfg={context.props.dataCfg} i18nManager={context.props.i18nManager} parentProps={context.props} callback={callbackModal}></EmailModal>);

        } else {
            Swal.fire({
                icon: "error",
                title: "Echec",
                html: "Aucune intervention n'est sélectionnée dans la liste"
            });
        }
    }
}

const withI18n = (Component) => {
    return props => {
        const i18n = useTranslation();
        return <Component {...props} i18nManager={{ ...i18n }} />
    }
}


export default withRouter(withI18n(ManageReportsItv));





//Création d'un "function component" pour gérer l'affichage du Dialog
//props correspond aux attributs fournies lors de la déclaration de ReportModal
export function ReportModal({ title, parentContext, noScroll, configModel, modelsList, dataReport, altSplitMode, customFilesTitle, callback }) {
    React.useEffect(() => {
        //console.debug("mount");

        //TODO : Check différence draft/ManualReport

        //if (parentContext.props.dataCfg && parentContext.props.dataCfg.dlgSup_enabledMClient) initClientList(null, 0);//TODO
        initReportModal();
    }, []);

    //const [contacts, setContacts] = React.useState([]);
    const [files, setFiles] = React.useState([]);


    function initReportModal() {
        
    }

    //console.debug("render modal");

    var defaultFileType = "PJ";
    var minFiles = 0;
    var maxFiles = 0;
    var noChooseTypes = false;
    var noTimestamp = false;
    var acceptFilter = {};
    if (altSplitMode) {
        minFiles = 1;
        maxFiles = 1;
        noChooseTypes = true;
        noTimestamp = true;
        acceptFilter = {
            "application/pdf": [
                ".pdf"
            ]
        };
    }



    var elemID = dataReport ? dataReport.idReport : 0;
    var elemName = "Rapport";
    var entity = "REPORT";

    //TODO : gérer le modal client en composant pour l'afficher dans ce modal
    configModel = JSON.parse(JSON.stringify(configModel));

    var btnAdd = altSplitMode ? <Button className="px-3" color="info" onClick={() => {
        var generateModel = parentContext.modalGenManager.current;
        if (generateModel && generateModel.submitForm) {
            generateModel.submitForm();
        }
    }}><i className="fa fa-envelope"></i>Envoyer</Button> : <Button className="px-3" color="success" onClick={() => {
        var generateModel = parentContext.modalGenManager.current;
        if (generateModel && generateModel.submitForm) {
            generateModel.submitForm();
        }
    }}><i className="fa fa-plus"></i>Ajouter</Button>;

    return (
        <Modal isOpen={true} className={`modal-report ${noScroll ? "modal-noscroll" : ""}`} size="xl" scrollable keyboard={false} toggle={() => { callback(); }} backdrop="static" style={{ paddingTop: "0px" }}>
            <ModalHeader className="d-flex" toggle={() => { callback(); }}>{title}</ModalHeader>
            <ModalBody className="px-2" style={{overflowX: "hidden"}}>
                <AGenerateModel parentProps={{ type: "report", dataCfg: parentContext.props.dataCfg }} ref={parentContext.modalGenManager} noButtons onSubmit={(data, isUpdate) => { if (files && files.length) { data.localFiles = files; } return callback(data, isUpdate) }} appProps={parentContext.props} checkRights={parentContext.props.checkRights} getRoutes={parentContext.props.getRoutes} configModel={configModel} modelsList={modelsList} loadedData={dataReport} />

                <FilesCustom className="reportDlg-files" title="FICHIERS JOINTS" bindID={elemID} checkRights={parentContext.props.checkRights} fileTypeID={entity} src={null} srcName={elemName}
                    files={files} setFiles={(compFiles) => { setFiles(compFiles) }}
                    noUploads={true} badgeRendering={false} withFilters={false} hideSync={true} shouldRender={true} onlyDelete={true} disabled={false} defaultFileType={defaultFileType}
                    altFilesTypes={`../api/${entity}/Get${entity}FilesType`} altFilesUrl={`../api/${entity}/Get${entity}Files`}
                    altRemoveFilesUrl={`../api/${entity}/Remove${entity}File`} altUploadFilesUrl={`../api/${entity}/Upload${entity}Files`}
                    accept={acceptFilter} noChooseTypes={noChooseTypes} noTimestamp={noTimestamp} minFiles={minFiles} maxFiles={maxFiles} openUploadOnCreate={altSplitMode} customTitle={customFilesTitle} />
            </ModalBody>
            <ModalFooter className="px-2 flex-nowrap">
                {
                    dataReport ? <Button className="px-3" color="success" onClick={() => {
                        var generateModel = parentContext.modalGenManager.current;
                        if (generateModel && generateModel.submitForm) {
                            generateModel.submitForm(true);
                        }
                    }}><i className="fa fa-edit"></i>Modifier</Button> : btnAdd
                }
                <Button className="px-3" color="danger" onClick={() => { callback(); }}><i className="fa fa-times"></i>Annuler</Button>
            </ModalFooter>
        </Modal>
    );
}


/*function sendExtEmailDialog(report, dataCfg, i18nManager) {
    var id = report.idReport;
    if (parseInt(id) > 0) {
        var title = this.props.i18nManager.t("report.title") + " • " + report.refID + report.refIDVersion + " • " + report.clientName;// getDtValue("lstActs", id, "Name") + " " + getDtValue("lstActs", id, "FirstName");

        var modalRoot;

        //Traitement des informations retourné par le Dialog
        var callbackModal = function () {
            modalRoot.unmount();
        };

        modalRoot = createRoot(document.createElement('div'));
        modalRoot.render(<EmailModal title={"Envoyer un Email  " + title} reportId={id} report={report} dataCfg={dataCfg} i18nManager={i18nManager} callback={callbackModal}></EmailModal>);

    } else {
        Swal.fire({
            icon: "error",
            title: "Echec",
            html: "Aucune intervention n'est sélectionnée dans la liste"
        });
    }
}*/

//Création du schéma pour le paramètrage du formulaire
const itvModalSchema = yup.object().shape({
    fromEmail: yup.object().required("Ce champ est obligatoire"),//.required("Ce champ est obligatoire"),
    targetsEmail: yup.array().min(1, "Veuillez renseigner un email").required("Ce champ est obligatoire"),//.required("Ce champ est obligatoire"),
    files: yup.array(),//.required("Ce champ est obligatoire"),
    objectLabel: yup.string().required("Ce champ est obligatoire")
}).required();

function EmailModal({ title, reportId, report, dataCfg, i18nManager, parentProps, callback }) {
    React.useEffect(() => {
        //console.debug("mount");

        initEmailModal();
    }, []);

    const [froms] = React.useState([]);
    const [contacts, setContacts] = React.useState([]);
    const [files, setFiles] = React.useState([]);
    const [objEml, setObjEml] = React.useState(null);
    const [emailStatus] = React.useState(<Col lg="10" className="alert alert-sm mb-0 wait" id="errorEmailAlert"><span className="input-icon">En Attente</span><span className="ms-3">Patientez SVP...</span></Col>);
    const [modelTemplates, setModelTemplates] = React.useState([]);
    const [template, setTemplate] = React.useState("");
    const [rerender, setRerender] = React.useState(false);

    const editorRef = React.useRef(null);

    const { register, getValues, setValue, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(itvModalSchema) });//{ resolver: yupResolver(currSchema), defaultValues: { ClientName: "toto" } }

    /*const { ref: refTgtEmail, ...restTgtEmail } =*/ register("targetsEmail");
    /*const { ref: refFiles, ...restFiles } =*/ register("files", { value: [] });
    const { ref: refObjectLabel, ...restObjectLabel } = register("objectLabel");

    function initEmailModal() {
        Swal.fire({
            title: i18nManager.t("gal_loading"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        /*var argsModel = { id: report.assignSiteID, level: 2 };
        commonFunc.getMethod("../api/site/GetSite", argsModel).then((responseSite) => {
            if (responseSite.data.isSuccess) {
                report.extSite = responseSite.data.result;*/

                var argsModel = { id: -1, categ: "REPORTS" };
                commonFunc.getMethod("../api/report/GetReportModels", argsModel).then((response) => {
                    if (response.data.isSuccess) {
                        if (response.data.result?.models) {
                            var curUser = parentProps.getUser();
                            var curSite = parentProps.getSite();
                            if (curSite.email) setValue("fromEmail", { email: curSite.email, name: curSite?.name, firstName: "" });
                            else setValue("fromEmail", { email: curUser.userLogin, name: curUser.userName, firstName: "" });

                            var mailModel = response.data.result?.models.filter(model => model.extID === "EML_CFG");
                            if (mailModel.length) {
                                var objEmlCurr = JSON.parse(mailModel[0].value);
                                setObjEml(objEmlCurr);

                                if (objEmlCurr?.Email?.Subject) setValue("objectLabel", objEmlCurr?.Email?.Subject);
                                //setValue("fromEmail", { email: report.extSite?.email, name: report.extSite?.name, firstName: "" });

                                var args = { id: reportId };
                                var defaultClient = [];
                                if (!commonFunc.isBlank(report.client?.email)) {
                                    defaultClient.push({ email: report.client?.email, name: report.client?.name, firstName: report.client?.firstName });
                                    setValue("targetsEmail", [defaultClient[0]]);
                                }

                                var contacts = [...defaultClient, ...report.contacts];

                                setContacts(contacts);
                                //setValue("targetsEmail", [{ email: report.client?.email, name: report.client?.name, firstName: report.client?.firstName }]);

                                if (objEmlCurr?.IncludeFiles) {
                                    //Appel réseau plutôt que dépendance sur report qui n'est pas actualisé juste après génération PDF
                                    var argsFiles = { bindID: args.id, fileId: -1 };
                                    commonFunc.getMethod("../api/report/GetReportFiles", argsFiles).then((response) => {//GetReportFinalFiles
                                        var data = response.data;
                                        if (data.isSuccess) {
                                            if (data.count > 0) {
                                                var filteredFiles;
                                                if (objEmlCurr.Email?.FilesTypes) filteredFiles = data.result.filter(file => objEmlCurr.Email.FilesTypes.indexOf(file.categ) >= 0);
                                                else filteredFiles = data.result;

                                                if (filteredFiles.length > 1) {
                                                    filteredFiles = filteredFiles.sort((a, b) => {
                                                        return moment(b.dSysMod).diff(a.dSysMod, "seconds");
                                                    });
                                                }

                                                setFiles(filteredFiles);
                                                if (filteredFiles.length) setValue("files", [filteredFiles[0]]);
                                            }
                                            //else {
                                            //    Swal.fire({
                                            //        icon: "warning",
                                            //        title: "Attention",
                                            //        html: "Aucun fichiers"
                                            //    });
                                            //}
                                        }
                                    });
                                }

                                if (objEmlCurr?.Email?.ModelCateg && objEmlCurr?.Email?.ModelExtId) {
                                    var argsModel = { id: -1, categ: objEmlCurr?.Email?.ModelCateg };
                                    commonFunc.getMethod("../api/report/GetReportModels", argsModel).then((response) => {
                                        if (response.data.isSuccess && response.data.result) {
                                            //console.debug(response.data.result);
                                            var mailModel = response.data.result.models.filter(model => objEmlCurr?.Email?.ModelExtId.indexOf(model.extID) >= 0);
                                            if (mailModel.length) {
                                                setModelTemplates(mailModel);
                                                updateHtmlContent(mailModel[0]);
                                            }


                                        }/* else {
                                            Swal.fire({
                                                icon: "error",
                                                title: "Echec",
                                                html: "Echec du chargement du template l'email<br/>" + response.data.errorMessage
                                            });
                                        }*/
                                    });
                                }

                                Swal.close();

                            } else {
                                Swal.fire({
                                    icon: "error",
                                    title: "Echec",
                                    html: "Echec du chargement de la configuration email<br/>Configuration introuvable"
                                });
                                setRerender(!rerender);
                            }
                        } else {
                            Swal.fire({
                                icon: "error",
                                title: "Echec",
                                html: "Echec du chargement de la configuration email<br/>Aucune configuration"
                            });
                        }
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: "Echec du chargement de la configuration email<br/>" + response.data.errorMessage
                        });
                    }
                });
            /*} else {
                Swal.fire({
                    icon: "error",
                    title: "Echec",
                    html: "Echec de récupération infos agences<br/>" + responseSite.data.errorMessage
                });
            }
        });*/
    }

    function updateHtmlContent(model, customContent) {
        var objHtml = JSON.parse(model.value);

        var content = customContent || objHtml.Details;
        var temp = document.createElement('div');
        temp.innerHTML = content;

        temp.querySelectorAll("[data-bind], [data-bindtype]").forEach((element) => {
            var valueBind;
            if (element.getAttribute("data-bindtype") === "address") {
                valueBind = commonFunc.getValue(report, element.getAttribute("data-bind") + ".addressMain") + " ";
                valueBind += commonFunc.getValue(report, element.getAttribute("data-bind") + ".addressPlus") + " ";
                valueBind += commonFunc.getValue(report, element.getAttribute("data-bind") + ".addressPlus2") + " ";
                valueBind += commonFunc.getValue(report, element.getAttribute("data-bind") + ".pc") + " ";
                valueBind += commonFunc.getValue(report, element.getAttribute("data-bind") + ".city");
            }
            else if (element.getAttribute("data-bindtype")?.startsWith && element.getAttribute("data-bindtype").startsWith("contacts;")) {
                valueBind = "";
                var contacts = commonFunc.getValue(report, element.getAttribute("data-bind"));
                if (contacts?.length) {
                    var filteredContacts = contacts.filter(contact => contact.contactType === element.getAttribute("data-bindtype").replace("contacts;", ""));
                    if (filteredContacts.length) {
                        valueBind = commonFunc.getValue(filteredContacts[0], element.getAttribute("data-subbind")) || ""
                    }
                }
                if (commonFunc.isBlank(valueBind) && element.getAttribute("data-fallback")) {
                    var subObj = commonFunc.getValue(report, element.getAttribute("data-fallback"));
                    if (subObj) valueBind = commonFunc.getValue(subObj, element.getAttribute("data-subbind")) || "";
                }
            }
            else {
                valueBind = commonFunc.getValue(report, element.getAttribute("data-bind")) || "";
            }

            if (element.getAttribute("data-format") === "phone") {
                valueBind = valueBind.replaceAll(" ", ".");
            }

            element.innerHTML = valueBind;
        });
        setTemplate("<br/>" + temp.innerHTML);
    }

    function triggerSubmit(data) {

        Swal.fire({
            title: 'Envoi de l\'Email en cours...',
            didOpen: () => { Swal.showLoading() },
        });

        ///console.debug(data);
        var args = objEml.Email;
        args.BindID = reportId;
        args.From = { Item1: data.fromEmail.email, Item2: data.fromEmail.name + (data.fromEmail.firstName ? (" " + data.fromEmail.firstName) : "") };
        args.To = {};
        data.targetsEmail.forEach(target => { args.To[target.email] = target.name + (target.firstName ? (" " + target.firstName) : "") });
        args.Subject = data.objectLabel;
        args.Attachments = data.files;
        args.SrcObject = reportId;
        args.ModelBindID = reportId;

        args.HtmlMessage = editorRef.current ? editorRef.current.getContent() : "";
        args.PlainMessage = editorRef.current ? editorRef.current.getContent({ format: "text" }) : "";
        console.debug(args);
        return;
        commonFunc.postMethod("../api/report/SendReportEmail", args).then((response) => {
            if (response.data && response.data.isSuccess) {
                Swal.fire({
                    icon: "success",
                    title: i18nManager.t("gal_success"),
                    html: "Email envoyé avec succès",
                    didOpen: () => { Swal.hideLoading() },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                }).then((result) => {
                    if (callback && typeof (callback) === "function") { callback(data); }
                });

            } else {
                Swal.fire({
                    icon: "error",
                    title: "Echec",
                    html: "Echec de l'envoi de l'email<br/>" + response.data.errorMessage
                });
            }
        });
    }

    //console.debug("render modal");

    //console.debug(getValues());
    //console.debug(errors);

    var bindPropResult = "targetsEmail";
    //var currValue = "";
    var inputStyle = {};

    var onChange = () => { };

    var customOpt = [];
    contacts.forEach((option, index) => {
        customOpt.push({ value: option.email, label: option.name + " " + option.firstName + " (" + option.email + ")" });
    });
    /*if (getValues(bindPropResult)) currValue = getValues(bindPropResult);
    else if (customOpt.length) currValue = customOpt[0].value;*/

    var compArgs = {
        isMulti: true,
        id: "targetContactsEmail",
        className: ` ${commonFunc.getValue(errors, bindPropResult) ? "react-select-invalid" : ""}`,
        isDisabled: false, /*innerRef={refElem} {...restElem}*/
        formatOptionLabel: (option, { context }) => {
            return option.label;
        },
        onChange: (e) => {
            //console.debug(e);
            if (Array.isArray(e)) {
                var values = e;
                values = e.map(v => {
                    var contactSrc = contacts.filter(contact => contact.email === v.value);
                    if (contactSrc.length) return contactSrc[0];
                    else return { email: v.value, name: v.label };
                });
                //values = e.map(v => v.value).join(";");
                onChange(values);
                setValue(bindPropResult, values);
            }
            else {
                onChange(e.value);
                setValue(bindPropResult, e.value);
            }
        },
        isValidNewOption: (inputValue, value) => {
            return /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(inputValue);// /[a-z]+@[a-z]+\.[a-z]+/
        },
        invalid: commonFunc.getValue(errors, bindPropResult) ? true : false,
        /*defaultValue: (() => {
            var arrayOptions;
            if (Array.isArray(currValue)) {
                arrayOptions = currValue;
            }
            else if (currValue && currValue.split) {
                arrayOptions = currValue.split(";");
            }
            //console.debug(currValue);
            //console.debug(arrayOptions);
            var option;
            if (arrayOptions) {
                option = arrayOptions.map((v, i) => {
                    if (!commonFunc.isBlank(v)) {
                        var value = parseInt(v) ? parseInt(v) : v;
                        var filterOption = customOpt.filter(opt => opt.value === value);
                        var label;
                        if (filterOption.length > 0) {
                            label = filterOption[0].label;
                        }
                        else {
                            label = v;
                        }
                        return { label: label, value: value };
                    }
                    else {
                        return "";
                    }
                });
            }
            else {
                var filterOption = customOpt.filter(opt => opt.value === currValue);
                var label;
                if (filterOption.length > 0) {
                    label = filterOption[0].label;
                }
                if (label) {
                    option = { label: label, value: currValue };
                }
                else {
                    option = (currValue ? currValue : "");
                }
            }
            return option;
        })(),*/
        options: customOpt,
        //styles: { control: inputStyle }
        styles: { /*option: (provided, state) => ({ ...provided, ...inputStyle }),*/ control: (provided) => ({ ...provided, ...inputStyle }) }
    };

    if (contacts?.length) {
        compArgs.key = "emails" + contacts?.length;
        compArgs.defaultValue = { label: customOpt[0].label, value: customOpt[0].value };
    }


    var bindPropResultFiles = "files";
    //var currValueFiles = "";

    var customOptFiles = [];
    files.forEach((option, index) => {
        customOptFiles.push({ value: option.idFile, label: option.name + " (" + option.prefix + ")" });
    });
    /*if (customOptFiles.length) {
        if (getValues(bindPropResultFiles)) currValue = getValues(bindPropResultFiles);
        else {
            var filteredFiles = files.filter(file => file.categ === "PDF");
            if (filteredFiles.length) {
                currValueFiles = filteredFiles[0].idFile;
            }
            else currValueFiles = customOpt[0].value; 
        }
    }*/

    var selFilesArgs = {
        isMulti: true,
        id: "targetFilesEmail",
        className: ` ${commonFunc.getValue(errors, bindPropResultFiles) ? "react-select-invalid" : ""}`,
        isDisabled: false, /*innerRef={refElem} {...restElem}*/
        formatOptionLabel: (option, { context }) => {
            return option.label;
        },
        onChange: (e) => {
            //console.debug(e);
            if (Array.isArray(e)) {
                var values = e;
                values = e.map(v => {
                    var fileSrc = files.filter(contact => contact.idFile === v.value);
                    if (fileSrc.length) return fileSrc[0];
                    else return null;
                });
                //values = e.map(v => v.value).join(";");
                onChange(values);
                setValue(bindPropResultFiles, values);
            }
            else {
                onChange(e.value);
                setValue(bindPropResultFiles, e.value);
            }
        },
        invalid: commonFunc.getValue(errors, bindPropResultFiles) ? true : false,
        /*defaultValue: (() => {
            var arrayOptions;
            if (Array.isArray(currValueFiles)) {
                arrayOptions = currValueFiles;
            }
            else if (currValueFiles && currValueFiles.split) {
                arrayOptions = currValueFiles.split(";");
            }
            console.debug(currValueFiles);
            console.debug(arrayOptions);
            var option;
            if (arrayOptions) {
                option = arrayOptions.map((v, i) => {
                    if (!commonFunc.isBlank(v)) {
                        var value = parseInt(v) ? parseInt(v) : v;
                        var filterOption = customOptFiles.filter(opt => opt.value === value);
                        var label;
                        if (filterOption.length > 0) {
                            label = filterOption[0].label;
                        }
                        else {
                            label = v;
                        }
                        return { label: label, value: value };
                    }
                    else {
                        return "";
                    }
                });
            }
            else {
                var filterOption = customOptFiles.filter(opt => opt.value === currValueFiles);
                var label;
                if (filterOption.length > 0) {
                    label = filterOption[0].label;
                }
                if (label) {
                    option = { label: label, value: currValueFiles };
                }
                else {
                    option = (currValueFiles ? currValueFiles : "");
                }
            }
            return option;
        })(),*/
        options: customOptFiles,
        //styles: { control: inputStyle }
        styles: { /*option: (provided, state) => ({ ...provided, ...inputStyle }),*/ control: (provided) => ({ ...provided, ...inputStyle }) }
    };

    if (files?.length) {
        selFilesArgs.key = "files" + files?.length;
        selFilesArgs.defaultValue = { label: customOptFiles[0].label, value: customOptFiles[0].value };
    }

    return (
        <Modal isOpen={true} className="modal-email" size="xl" keyboard={false} toggle={() => { callback(); }} backdrop="static" style={{ paddingTop: "0px" }}>
            <ModalHeader className="d-flex" toggle={() => { callback(); }}>{title || "Transfert de Fichiers"}</ModalHeader>
            <ModalBody className="px-2">
                <Row className="m-0 mb-3 px-1 d-none">
                    <Col className="align-content-center text-lg-end" lg="2">
                        <label className="m-0">Etat du service:</label>
                    </Col>
                    {emailStatus}
                </Row>
                <div className="mail-box">
                    <Form id="frmsendmail" action="" className="form needs-validation" method="" onSubmit={handleSubmit(triggerSubmit)}>
                        <div className="mail-body">
                            <FormGroup>
                                <Row>
                                    <Col className="align-content-center text-lg-end" lg="2">
                                        <label className="m-0 mandatory">De:</label>
                                    </Col>
                                    <Col lg="8" style={{ zIndex: 3 }}>
                                        {froms?.length ? <CreatableSelect {...compArgs} /> : (() => {
                                            var email = getValues("fromEmail");
                                            return email ? (email.name + " (" + email.email + ");") : "";
                                        })()}
                                        <FormFeedback className={`text-start ${commonFunc.getValue(errors, "fromEmail") ? "d-block" : ""}`}>{errors.fromEmail ? errors.fromEmail.message : "Ce champ est obligatoire"}</FormFeedback>
                                    </Col>
                                </Row>
                            </FormGroup>

                            <FormGroup>
                                <Row>
                                    <Col className="align-content-center text-lg-end" lg="2">
                                        <label className="m-0 mandatory">A:</label>
                                    </Col>
                                    <Col lg="8">
                                        {<CreatableSelect {...compArgs} />/*contacts?.length ? <CreatableSelect {...compArgs} /> : (() => {
                                            var emails = getValues("targetsEmail");
                                            return emails?.map(option => option.name + "(" + option.email + ");");
                                        })()*/}
                                        <FormFeedback className={`text-start ${commonFunc.getValue(errors, "targetsEmail") ? "d-block" : ""}`}>{errors.targetsEmail ? errors.targetsEmail.message : "Ce champ est obligatoire"}</FormFeedback>
                                    </Col>
                                </Row>
                            </FormGroup>

                            <FormGroup>
                                <Row>
                                    <Col className="align-content-center text-lg-end" lg="2">
                                        <label className="m-0 mandatory">Objet:</label>
                                    </Col>
                                    <Col lg="10">
                                        <Input id="targetSubject" name="Objet" placeholder="Objet" type="text" autoComplete="off" aria-autocomplete="none"
                                            innerRef={refObjectLabel} {...restObjectLabel}
                                            invalid={errors.objectLabel ? true : false} />
                                        <FormFeedback className={`text-start ${commonFunc.getValue(errors, "objectLabel") ? "d-block" : ""}`}>{errors.objectLabel ? errors.objectLabel.message : "Ce champ est obligatoire"}</FormFeedback>
                                    </Col>
                                </Row>
                            </FormGroup>

                            {objEml?.IncludeFiles ? <FormGroup>
                                <Row>
                                    <Col className="align-content-center text-lg-end" lg="2">
                                        <label className="m-0">Fichiers:</label>
                                    </Col>
                                    <Col lg="10" style={{ zIndex: 3 }}>
                                        <Select {...selFilesArgs} />
                                        <FormFeedback className={`text-start ${commonFunc.getValue(errors, "files") ? "d-block" : ""}`}>{errors.files ? errors.files.message : "Ce champ est obligatoire"}</FormFeedback>
                                    </Col>
                                </Row>
                            </FormGroup> : ""}

                            <FormGroup>
                                <Row>
                                    <Col className="align-content-center text-lg-end" lg="2">
                                        <label className="m-0">Type de message:</label>
                                    </Col>
                                    <Col lg="6">
                                        <Input id={"selectMsgType"} style={inputStyle} type="select" onChange={(e) => {
                                            var model = modelTemplates.filter(model => model.idModel === parseInt(e.target.value));
                                            if (model.length) {
                                                updateHtmlContent(model[0]);
                                            }
                                        }}>
                                            {modelTemplates.map((option, index) => <option key={index} value={option.idModel}>
                                                {option.title}
                                            </option>)}
                                        </Input>
                                    </Col>
                                </Row>
                            </FormGroup>

                        </div>
                        <Editor
                            onInit={(evt, editor) => editorRef.current = editor}
                            initialValue={template}
                            init={{
                                language: "fr_FR",
                                valid_elements: '*[*]',
                                valid_children: "+body[style]",
                                height: 410,
                                menubar: false,
                                //readonly: true, >> cf disabled
                                plugins: [
                                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                    'insertdatetime', 'media', 'table', 'help', 'wordcount'
                                ],
                                toolbar: 'undo redo | blocks | fontsize | ' +
                                    'bold italic forecolor | alignleft aligncenter ' +
                                    'alignright alignjustify | bullist numlist outdent indent | ' +
                                    'removeformat',
                                content_style: `body { font-family:Helvetica,Arial,sans-serif; font-size:14px} 
                                #mtnfr {font-family:Nunito} 
                                .sepline { border: 1px dashed red; }
                                .displayNone { display: none }
                                .d-none { display: none }`
                            }}
                        />
                        <button type="button" id="btnSaveEmailSig" className="btn btn-sm btn-simple btn-dark btn-ok mt-3 d-none"><i className="fa fa-pencil-alt"></i>&nbsp;Définir signature</button>
                    </Form>
                </div>

            </ModalBody>
            <ModalFooter className="px-2 flex-nowrap">
                <Button className="px-3" color="primary" form="frmsendmail"><i className="fa fa-reply"></i>Envoyer</Button>
                <Button className="px-3" color="secondary" onClick={() => { callback(); }}>Fermer</Button>
            </ModalFooter>
        </Modal>
    );
}

//Utilisations : ManageReportsItv/Planning
export async function addReport(userReport, dataReport, isUpdate, args) {
    userReport.employeeID = userReport.itv.employeeID;
    console.debug(userReport);

    //TODO : reprendre l'affichage heures variant en fonction du service
    //userReport.itv.startDate = new Date(userReport.itv.startDate);//TEMP : valeur mal stocké dans react hook form
    if (args?.lengthSystem) {
        if (!userReport.itv.length) userReport.itv.length = dataReport.itv.length || 1.5;//TEMP

        if (commonFunc.isValidDate(userReport.itv.startDate)) {
            userReport.itv.endDate = commonFunc.addMinutes(userReport.itv.startDate, userReport.itv.length * 60);
        }
        else {
            //userReport.itv.startDate = new Date(0);
            userReport.itv.startDate = moment("1970-01-01T00:00").toDate();
            userReport.itv.endDate = userReport.itv.startDate;
        }
        //userReport.itv.endDate = "2099-01-01T01:00:00";
    }
    else {
        if (commonFunc.isValidDate(userReport.itv.startDate) && commonFunc.isValidDate(userReport.itv.endDate)) {
            userReport.itv.length = moment(userReport.itv.endDate).diff(moment(userReport.itv.startDate), 'hours', true);
            //userReport.itv.length = (userReport.itv.endDate - userReport.itv.startDate) * 60 * 60;
        }
        else {
            //userReport.itv.startDate = new Date(0);
            if (!commonFunc.isValidDate(userReport.itv.startDate)) userReport.itv.startDate = moment("1970-01-01T00:00").toDate();
            if (!commonFunc.isValidDate(userReport.itv.endDate)) userReport.itv.endDate = moment("1970-01-01T00:00").toDate();
            userReport.itv.length = 0;
        }
    }

    var flag = true;
    if (userReport.contacts) {
        userReport.contacts = userReport.contacts.filter(item => item !== null && item !== undefined);
        userReport.contacts.forEach((contact) => {
            flag &= !(contact.isNotifiedSMS && commonFunc.isBlank(contact.gsm));
        });
    }
    //TODO : voir si possible de gérer les tests dans react hook form
    if (!(flag /*&& userReport.employeeID > 0*/ && commonFunc.isValidDate(userReport.itv.startDate))) {
        console.debug(userReport.itv.startDate);
        console.debug(commonFunc.isValidDate(userReport.itv.startDate));
        if (!flag) {
            Swal.fire({
                icon: 'warning',
                title: "Veuillez renseigner un numéro de mobile pour Envoi Sms.",
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
            });
        }
        /*else if (userReport.employeeID <= 0) {
            Swal.fire({
                icon: 'warning',
                title: "Veuillez saisir un intervenant valide.",
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
            });
        }*/
        else {
            Swal.fire({
                icon: 'warning',
                title: "Veuillez saisir une date et/ou une heure valide.",
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
            });
        }
        return new Promise((resolve, reject) => {
            resolve({ isSuccess: false });
        });
    }
    if (!commonFunc.isValidDate(userReport.itv.startDate) || !commonFunc.isValidDate(userReport.itv.endDate)) {
        Swal.fire({
            icon: 'error',
            title: 'Echec',
            html: "Veuillez renseigner des dates valides"
        });
        return new Promise((resolve, reject) => {
            resolve({ isSuccess: false });
        });
    }
    else if (moment(userReport.itv.endDate).isBefore(userReport.itv.startDate)) {
        Swal.fire({
            icon: 'error',
            title: 'Echec',
            html: "La date de fin d'intervention doit se situer après la date de début"
        });
        return new Promise((resolve, reject) => {
            resolve({ isSuccess: false });
        });
    }

    var autoSend = parseInt(userReport.statusID) === parseInt(userReport.cAutoSend);
    if (autoSend && (userReport.itv.startDate.getFullYear() <= 1970 || userReport.itv.employeeID <= 0 || !commonFunc.isPlanDate(userReport.itv.startDate))) {
        if (userReport.itv.startDate.getFullYear() <= 1970 || userReport.itv.employeeID <= 0) {
            Swal.fire({
                icon: 'error',
                title: 'Echec',
                html: "Veuillez renseigner une date de début, une durée/date de fin ainsi qu'un intervenant afin d'envoyer le rapport"
            });
        }
        else {
            Swal.fire({
                icon: 'error',
                title: 'Echec',
                html: "La date ne doit pas précéder l'année dernière pour valider la planification"
            });
        }
        return new Promise((resolve, reject) => {
            resolve({ isSuccess: false });
        });
    }

    Swal.fire({
        title: args.translation("gal_saving"),
        didOpen: () => { Swal.showLoading() },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
    });

    //TODO : voir si on garde ce principe ou pas (>> création d'un nouveau rapport à chaque modification)
    var removeInfos;
    if (dataReport && dataReport.idReport) {
        removeInfos = {}
        var id = dataReport.idReport;
        if (id > 0 /*&& data.result.StatusID < 202*/) {
            removeInfos.id = id;
        }
        else {
            return;
        }
        removeInfos.isPermanent = false;

        userReport.dSysCreat = dataReport.DSysCreat;
    }
    else {
        userReport.dSysCreat = new Date();
    }


    userReport.idReport = isUpdate ? dataReport.idReport : 0;

    //TODO : voir si on reprend le système avec ID Temporaire pour les clients ou pas (configuration qui définissais si un module client était actif ou non ???)
    userReport.clientID = dataReport.clientID || userReport.clientID || 0;//PATCH POUR TEST SUIVANT : userReport.clientID === 0
    userReport.statusID = (autoSend ? 212 : userReport.statusID);

    userReport.employee = null;

    userReport.siteAddressID = isUpdate ? dataReport.siteAddressID : (userReport.siteAddressID || 0);
    if (userReport.address) {
    userReport.address.idAddress = userReport.siteAddressID;
    userReport.address.title = "Adresse Interv.";
    userReport.address.categ = "SITE";
    }
    userReport.billAddressID = isUpdate ? dataReport.billAddressID : (userReport.billAddressID || 0);
    if (userReport.billAddress) {
    userReport.billAddress.idAddress = userReport.billAddressID;
    userReport.billAddress.title = "Adresse de factu";
    userReport.billAddress.categ = "INVOICE";
    }

    var orgClientName = userReport.client?.name || "";
    if (userReport.clientID) {
        userReport.client = null;
    }
    else if (userReport.clientID === 0 && !commonFunc.isBlank(userReport.client.name)) {
        if (!userReport.client) userReport.client = {};
        //userReport.client.siteID = -1;
        userReport.client.statusID = -1;
        userReport.client.stepID = -1;
        userReport.client.categoryID = -1;

        userReport.client.addressID = 0;
        userReport.client.address = userReport.address;
        userReport.client.billingAddressID = 0;
        userReport.client.billingAddress = userReport.billAddress;
    }


    userReport.sitePlaceType = "";

    //userReport.startDate = moment(userReport.itv.startDate).utc().format("YYYY-MM-DDTHH:mm:ss");//Date sinistre
    //userReport.assistantMail = "no@email.fr";
    //userReport.assistantPhone = "02 01 01 01 01";

    userReport.planItvID = isUpdate ? dataReport.planItvID : -1;
    userReport.itv.idEvent = isUpdate ? dataReport.itv.idEvent : 0;
    userReport.itv.clientID = userReport.clientID;
    userReport.itv.reportID = isUpdate ? dataReport.itv.reportID : -1;//PATCH Création ITV //0
    //userReport.itv.length = 1.0;
    userReport.itv.statusID = isUpdate ? dataReport.itv.statusID : 8;

    userReport.itv.employee = null;

    //INFO : changer le reportID et le siteID du planning_events pour racoller avec le rapport



    var tempReport = commonFunc.mergeDeep({}, dataReport, userReport);
    console.debug(dataReport);
    console.debug(tempReport);



    console.debug(userReport);
    //Swal.close();//TEMP
    //return new Promise((resolve, reject) => { resolve({ isSuccess: false }); });//TEMP
    return new Promise((resolveMain, rejectMain) => {
        commonFunc.postMethod(isUpdate ? "../api/report/UpdateReport" : "../api/report/CreateReport", userReport).then((response) => {
            Swal.close();
            var data = response.data;
            if (data && data.isSuccess) {

                var dlModal;

                var callbackSaveProc = async function (finalFiles, errors) {
                    return new Promise((resolve, reject) => {

                        if (dlModal) {
                            dlModal.unmount();
                            dlModal = null;
                        }

                        var nextProc = () => {
                            /*context.getReports(0, true, () => {
                                showDtSelID("tableReports", data.result.idReport);
                            });*/

                            var dataResult = data.result;
                            var currentData = userReport;//altValue || getValues();
                            //var statusID = ((componentArgs && componentArgs.statusItv) ? componentArgs.statusItv : dataResult.itv.statusID);
                            var statusID = dataResult.itv.statusID;

                            console.debug(currentData);

                            var itv = {};
                            //Récup data
                            /*itv.ReportItvID = loadedData.idReport;
                            itv.IsSet = true;
                            itv.ServiceID = loadedData.benefitID;
                            itv.StartDate = moment((loadedData.itv.startDate instanceof Date) ? loadedData.itv.startDate : commonFunc.restStringToDate(loadedData.itv.startDate)).utc(true).toDate();
                            itv.EndDate = commonFunc.addMinutes(itv.StartDate, 90);
                            itv.EmployeeID = loadedData.itv.employeeID;
                            itv.Name = loadedData.itv.employee.name + " " + loadedData.itv.employee.firstName;
                            itv.Title = loadedData.client.name + " [" + loadedData.refID + "]    " + loadedData.address.pc;
                            itv.Comments = loadedData.address.addressMain + " " + loadedData.address.addressPlus + " " + loadedData.address.addressPlus2 + " " + loadedData.address.pc + " " + loadedData.address.city;
            
                            itv.Phone = loadedData.employee.gsm;
                            itv.Email = "";
                            itv.Length = 1.5;
                            itv.Tel = loadedData.employee.tel;
                            itv.Email = "";
                            itv.Version = loadedData.refIDVersion;*/

                            //Récup partiel front (getValues)
                            //itv.reportItvID = loadedData.idReport;
                            itv.idEvent = dataResult.itv.idEvent;
                            itv.reportID = dataResult.idReport;
                            //itv.isSet = true;
                            itv.serviceID = currentData.itv.serviceID;
                            var sd = currentData.itv.startDate;
                            itv.startDate = (sd instanceof Date) ? sd : commonFunc.restStringToDate(sd);
                            itv.endDate = commonFunc.addMinutes(itv.startDate, currentData.itv.length * 60);
                            itv.employeeID = currentData.itv.employeeID;
                            //itv.name = loadedData.itv.employee.name + " " + loadedData.itv.employee.firstName;
                            itv.title = orgClientName + " [" + dataResult.refID + "]    " + dataResult.address?.pc;//TODO : voir pour concatener les champs
                            itv.comments = orgClientName + " " + (dataResult.address ? (dataResult.address.addressPlus + " " + dataResult.address.addressPlus2 + " " + dataResult.address.pc + " " + dataResult.address.city) : "");

                            //itv.phone = getValues("employee.gsm");//TODO ?
                            //itv.email = "";
                            itv.length = currentData.itv.length;
                            //itv.tel = loadedData.employee.tel;
                            //itv.version = loadedData.refIDVersion;
                            itv.statusID = statusID;

                            if (currentData.cItvStep !== undefined && currentData.cItvValue !== undefined) {
                                if (currentData.cItvStep >= 0) {
                                    itv.statusID = 2;
                                }
                                else {
                                    itv.statusID = 8;
                                }
                                if (currentData.cItvStep === 0 && currentData.cItvValue === 1) {
                                    itv.isValid = true;
                                }
                                else {
                                    itv.isValid = false;
                                }
                            }
                            else {
                                itv.statusID = 2;
                                itv.isValid = dataResult.itv.isValid;
                            }

                            if (currentData.statusID) {
                                itv.statusRequest = {};
                                itv.statusRequest.id = itv.reportID;
                                itv.statusRequest.newStatus = autoSend ? 212 : currentData.statusID;
                                itv.statusRequest.newStep = currentData.stepID;
                            }

                            if (itv.employeeID > 0 && commonFunc.isPlanDate(itv.startDate)) {
                                Swal.fire({
                                    title: 'Opération en cours...',
                                    didOpen: () => { Swal.showLoading() },
                                });

                                commonFunc.postMethod("../api/report/ScheduleItvReport", itv).then((response) => {
                                    Swal.close();
                                    var dataItv = response.data;
                                    if (dataItv?.isSuccess) {
                                        if (autoSend && dataItv.result?.reportID) {
                                            sendReport({ id: dataItv.result.reportID, newStatus: (currentData.cAutoSend || 202) }, args).then((response) => {
                                                if (dataItv.result) dataItv.result.idResponse = dataItv.result.reportID;
                                                resolveMain(dataItv);
                                            });
                                        }
                                        else {
                                            Swal.fire({
                                                icon: "success",
                                                title: args.translation("gal_success"),
                                                html: "Assignation effectuée avec succès",
                                                didOpen: () => { Swal.hideLoading() },
                                            }).then((result) => {
                                                /*onActionRequired(tag, { trigger: "refreshElem" }, componentData, componentArgs).then((responseLoad) => {
                                                    responseAction = responseLoad;
                                                    resolve(responseAction);
                                                });
            
                                                chainEvents(componentData, value);*/
                                                if (dataItv.result) dataItv.result.idResponse = dataItv.result.reportID;
                                                resolveMain(dataItv);
                                            });
                                        }
                                    } else {
                                        /*responseAction.errorMessage = "Echec de l'assignation : " + dataItv.errorMessage;
                                        responseAction.forceMessage = true;
                                        resolve(responseAction);*/

                                        Swal.fire({
                                            icon: "error",
                                            title: args.translation("gal_fail"),
                                            html: args.translation("gal_errorSave") + " :<br>Echec de l'assignation : " + dataItv.errorMessage
                                        }).then((result) => {
                                            if (dataItv.result) dataItv.result.idResponse = dataItv.result.reportID;
                                            else {
                                                dataItv.isSuccess = true;
                                                dataItv.result = { idResponse: data.result.idReport };
                                            }
                                            resolveMain(dataItv);
                                        });
                                    }
                                    //if (parentProps.autoClose) ref.current.submitForm("success");
                                });


                            } else {
                                /*responseAction.errorMessage = "MAJ impossible. Données invalides";
                                resolve(responseAction);
                                if (parentProps.autoClose) ref.current.submitForm("cancel");*/
                                if (data.result) data.result.idResponse = data.result.idReport;
                                resolveMain(data);
                            }
                        };

                        if (args.noSwal) {
                            nextProc();
                        }
                        else {
                            Swal.fire({
                                icon: errors && errors.length ? "warning" : "success",
                                title: args.translation("gal_success"),
                                html: (isUpdate ? args.translation("gal_successUpd") : args.translation("gal_successAdd"))
                                    + (errors && errors.length ? ("<br><b>Certains fichiers n'ont pas pu être mis en ligne :</b><br/>" + errors.map((errorFile) => errorFile.name + " : " + errorFile.error) + "<br>") : ""),
                                didOpen: () => {
                                    Swal.hideLoading();

                                    /*if (errorFiles.length) {
                                        $(".swal2-content").append("<br><b>Certains fichiers n'ont pas pu être envoyés. Transférer les manuellement.</b>");
                                        $.each(errorFiles, function (i, e) {
                                            var div = $("<div class='text-danger' style='font-size:90%'>" + $(e).find(".file-name").text().replace($(e).find(".file-name small").text(), "") + "</div>");
                                            $(".swal2-content").append(div);
                                        });
                                    }*/
                                },
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                allowEnterKey: false,
                            }).then((result) => {

                                nextProc();
                        });
                        }

                        data.result.idResponse = data.result.idReport;
                        resolve(data.result);
                    });
                };


                if (userReport.localFiles?.length) {
                    dlModal = createRoot(document.createElement('div'));
                    dlModal.render(<ExtUpload url={`../api/report/UploadReportFiles`} bindID={data.result.idReport} fileTypeID={"REPORT"} files={userReport.localFiles} callback={callbackSaveProc} />);
                }
                else {
                    callbackSaveProc();
                }

            } else {
                var supErrors = "";
                if (data.errors?.length) {
                    supErrors = data.errors.map((error) => {
                        return "<br>" + error.desc + "(" + error.value + ")";
                    });
                }
                Swal.fire({
                    icon: "error",
                    title: args.translation("gal_fail"),
                    html: args.translation("gal_errorSave") + " :<br>" + data.errorMessage + supErrors
                });

                resolveMain(data);
            }
        });
    });
}


export function sendReport(requestArgs, args) {
    Swal.fire({
        title: 'Envoi en cours...',
        didOpen: () => { Swal.showLoading() },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
    });

    return new Promise((resolve, reject) => {
        commonFunc.postMethod("../api/report/PrepareReport", requestArgs).then((response) => {
            Swal.close();
            if (response.data && response.data.isSuccess) {
                Swal.fire({
                    icon: "success",
                    title: args.translation("gal_success"),
                    html: "Envoi effectué avec succès.<br/>Rapport accessible à la saisie depuis l'application mobile.",
                    didOpen: () => { Swal.hideLoading() },
                }).then((result) => {
                    resolve(response.data);
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Echec",
                    html: "Echec de mise à jour du statut<br/>" + response.data.errorMessage
                });
                resolve(response.data);
            }
        });
    });
}